// import React, { useEffect, useRef, useState } from "react";
// import {
//   ChevronLeftIcon,
//   PaperAirplaneIcon,
// } from "@heroicons/react/24/outline";
// import "../CSS/Message.css";
// import "../CSS/CustomerChat.css";

// // Utility functions
// const generateUserId = () => {
//   let userId = localStorage.getItem("chatbot_user_id");
//   if (!userId) {
//     userId = "user_" + Math.random().toString(36).substr(2, 9);
//     localStorage.setItem("chatbot_user_id", userId);
//   }
//   return userId;
// };

// const AutomatedBot = ({
//   setView,
//   setupDetails,
//   widgetConfigs,
//   setActiveIcon,
// }) => {
//   const [messages, setMessages] = useState([]);
//   const [currentQuestion, setCurrentQuestion] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [conversationEnded, setConversationEnded] = useState(false);
//   const [userInput, setUserInput] = useState("");
//   const [initialized, setInitialized] = useState(false);
//   const [validationError, setValidationError] = useState("");
//   const [isValid, setIsValid] = useState(true);
//   const chatContainerRef = useRef(null);
//   const processingRef = useRef(false);

//   // Validation function
//   const validateInput = (input, currentQuestion) => {
//     if (!currentQuestion || !currentQuestion.dataCollection) {
//       return { isValid: true, error: "" };
//     }

//     const { dataCollection } = currentQuestion;

//     // Required field check
//     if (dataCollection.isRequired && (!input || input.trim().length === 0)) {
//       return { isValid: false, error: "This field is required" };
//     }

//     if (!input || input.trim().length === 0) {
//       return { isValid: true, error: "" };
//     }

//     // Length validation
//     if (
//       dataCollection.validation?.minLength &&
//       input.length < dataCollection.validation.minLength
//     ) {
//       return {
//         isValid: false,
//         error: `Minimum ${dataCollection.validation.minLength} characters required`,
//       };
//     }

//     if (
//       dataCollection.validation?.maxLength &&
//       input.length > dataCollection.validation.maxLength
//     ) {
//       return {
//         isValid: false,
//         error: `Maximum ${dataCollection.validation.maxLength} characters allowed`,
//       };
//     }

//     // Data type validation
//     switch (dataCollection.dataType) {
//       case "email":
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(input)) {
//           return {
//             isValid: false,
//             error: "Please enter a valid email address",
//           };
//         }
//         break;

//       case "phone":
//         const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
//         const cleanPhone = input.replace(/[\s\-\(\)]/g, "");
//         if (!phoneRegex.test(cleanPhone)) {
//           return { isValid: false, error: "Please enter a valid phone number" };
//         }
//         break;

//       case "number":
//         if (isNaN(Number(input))) {
//           return { isValid: false, error: "Please enter a valid number" };
//         }
//         break;

//       case "url":
//         try {
//           new URL(input);
//         } catch {
//           return { isValid: false, error: "Please enter a valid URL" };
//         }
//         break;

//       case "name":
//         const nameRegex = /^[a-zA-Z\s]{2,50}$/;
//         if (!nameRegex.test(input)) {
//           return {
//             isValid: false,
//             error: "Please enter a valid name (2-50 characters, letters only)",
//           };
//         }
//         break;
//     }

//     // Custom pattern validation
//     if (dataCollection.validation?.pattern) {
//       const customRegex = new RegExp(dataCollection.validation.pattern);
//       if (!customRegex.test(input)) {
//         return {
//           isValid: false,
//           error:
//             dataCollection.validation.errorMessage || "Invalid input format",
//         };
//       }
//     }

//     return { isValid: true, error: "" };
//   };

//   // Input change handler with validation
//   const handleInputChange = (value) => {
//     setUserInput(value);

//     // Validate input in real-time for data_collection questions
//     if (currentQuestion && currentQuestion.type === "data_collection") {
//       const validation = validateInput(value, currentQuestion);
//       setIsValid(validation.isValid);
//       setValidationError(validation.error);
//     } else {
//       setIsValid(true);
//       setValidationError("");
//     }
//   };

//   // Clear validation when question changes
//   useEffect(() => {
//     setValidationError("");
//     setIsValid(true);
//     setUserInput("");
//   }, [currentQuestion]);

//   // Auto-scroll to bottom when messages change
//   useEffect(() => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTo({
//         top: chatContainerRef.current.scrollHeight,
//         behavior: "smooth",
//       });
//     }
//   }, [messages]);

//   // Initialize chat when component mounts
//   useEffect(() => {
//     if (!initialized && !processingRef.current) {
//       initializeChat();
//     }
//   }, [initialized]);

//   const initializeChat = async () => {
//     if (processingRef.current) return;
//     processingRef.current = true;

//     try {
//       setLoading(true);
//       console.log(
//         "🤖 Initializing automated chat for:",
//         widgetConfigs.uniquePartnerId
//       );

//       const response = await fetch(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/start?uniquePartnerId=${widgetConfigs.uniquePartnerId}`
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const firstQuestion = await response.json();
//       console.log("📝 First question received:", firstQuestion);

//       setCurrentQuestion(firstQuestion);
//       setInitialized(true);

//       // Add welcome message
//       setTimeout(() => {
//         addMessage("bot", firstQuestion.text);

//         // Handle auto-advance for message types
//         if (
//           firstQuestion.type === "message" &&
//           firstQuestion.messageSettings?.autoAdvance
//         ) {
//           setTimeout(() => {
//             handleAutoAdvance(firstQuestion);
//           }, firstQuestion.messageSettings.delay || 1500);
//         }
//       }, 500);
//     } catch (error) {
//       console.error("❌ Failed to initialize automated chat:", error);
//       addMessage(
//         "bot",
//         "Hi! I'm having trouble connecting right now. Please try again later."
//       );
//       setInitialized(true);
//     } finally {
//       setLoading(false);
//       processingRef.current = false;
//     }
//   };

//   const handleAutoAdvance = async (currentQ) => {
//     if (processingRef.current) return;
//     processingRef.current = true;

//     try {
//       if (!currentQ.nextQuestionId) {
//         console.log("🔚 No next question, ending conversation");
//         setTimeout(() => {
//           addMessage("bot", "Thank you for your time!");
//           setConversationEnded(true);
//         }, 800);
//         setCurrentQuestion(null);
//         return;
//       }

//       setLoading(true);
//       console.log("➡️ Auto-advancing to:", currentQ.nextQuestionId);

//       const response = await fetch(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/${currentQ.nextQuestionId}?uniquePartnerId=${widgetConfigs.uniquePartnerId}`
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const nextQuestion = await response.json();
//       console.log("📝 Next question loaded:", nextQuestion.text);

//       setCurrentQuestion(nextQuestion);

//       setTimeout(() => {
//         addMessage("bot", nextQuestion.text);

//         // Continue auto-advance if needed
//         if (
//           nextQuestion.type === "message" &&
//           nextQuestion.messageSettings?.autoAdvance
//         ) {
//           setTimeout(() => {
//             handleAutoAdvance(nextQuestion);
//           }, nextQuestion.messageSettings.delay || 1500);
//         }
//       }, 800);
//     } catch (error) {
//       console.error("❌ Error in auto-advance:", error);
//       addMessage("bot", "Sorry, something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//       processingRef.current = false;
//     }
//   };

//   const addMessage = (type, text, timestamp = new Date()) => {
//     const newMessage = {
//       sender: type === "user" ? "Customer" : "Agent",
//       message: text,
//       timestamp: timestamp.toISOString(),
//       attachment: null,
//       attachmentType: null,
//       type: type === "user" ? "Customer" : "Agent",
//     };
//     setMessages((prev) => [...prev, newMessage]);
//   };

//   const handleSendMessage = async (userAnswer) => {
//     if (processingRef.current) return;

//     // ✅ Add client-side validation before sending
//     if (currentQuestion && currentQuestion.type === "data_collection") {
//       const validation = validateInput(userAnswer, currentQuestion);
//       if (!validation.isValid) {
//         setValidationError(validation.error);
//         setIsValid(false);
//         return; // Don't send if validation fails
//       }
//     }

//     processingRef.current = true;

//     try {
//       setLoading(true);
//       setValidationError(""); // Clear any existing errors

//       // Add user message if provided
//       if (userAnswer && userAnswer.trim()) {
//         addMessage("user", userAnswer);
//         setUserInput("");
//       }

//       console.log("💬 Processing user response:", userAnswer);

//       const response = await fetch(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/answer`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             userId: generateUserId(),
//             questionId: currentQuestion._id,
//             answer: userAnswer || "",
//             uniquePartnerId: widgetConfigs.uniquePartnerId,
//           }),
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         if (response.status === 400 && errorData.validationError) {
//           setValidationError(errorData.validationError);
//           setIsValid(false);
//           return;
//         }
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const result = await response.json();
//       console.log("📨 API Response:", result);

//       // ✅ Save conversation entry after successful API response
//       try {
//         console.log("💾 Saving conversation entry...");
//         const conversationResponse = await fetch(
//           `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/conversations`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               userId: generateUserId(),
//               questionId: currentQuestion._id,
//               questionText: currentQuestion.text,
//               answer: userAnswer || "",
//               uniquePartnerId: widgetConfigs.uniquePartnerId,
//               answerType: currentQuestion.type || "text",
//               // Add additional data if available
//               answerData: {
//                 originalValue: userAnswer,
//                 dataType: currentQuestion.dataCollection?.dataType || "text",
//                 isValid: true,
//               },
//             }),
//           }
//         );

//         if (conversationResponse.ok) {
//           console.log("✅ Conversation saved successfully");
//         } else {
//           console.warn("⚠️ Failed to save conversation, but continuing...");
//         }
//       } catch (convError) {
//         console.error("❌ Failed to save conversation:", convError);
//         // Don't fail the main flow if conversation saving fails
//       }

//       // Handle response based on action
//       switch (result.action) {
//         case "external_link":
//           console.log("🔗 Opening external link:", result.externalLink);
//           // ✅ Open external link immediately
//           if (result.externalLink) {
//             window.open(result.externalLink, "_blank", "noopener,noreferrer");
//           }

//           setTimeout(() => {
//             if (result.nextQuestion) {
//               addMessage("bot", "Link opened! Meanwhile...");
//               setTimeout(() => {
//                 setCurrentQuestion(result.nextQuestion);
//                 addMessage("bot", result.nextQuestion.text);
//               }, 1000);
//             } else {
//               addMessage("bot", "Link opened in new tab. Thank you!");
//               setConversationEnded(true);
//               // ✅ Mark conversation as completed
//               markConversationComplete();
//             }
//           }, 800);
//           break;

//         case "external_link_with_followup":
//           console.log(
//             "🔗 Opening external link with followup:",
//             result.externalLink
//           );
//           // ✅ Open external link immediately
//           if (result.externalLink) {
//             window.open(result.externalLink, "_blank", "noopener,noreferrer");
//           }

//           if (result.nextQuestion) {
//             setTimeout(() => {
//               setCurrentQuestion(result.nextQuestion);
//               addMessage("bot", "Great! I've opened the link in a new tab.");
//               setTimeout(() => {
//                 addMessage("bot", result.nextQuestion.text);
//               }, 1000);
//             }, 800);
//           }
//           break;

//         case "end_conversation":
//           setTimeout(() => {
//             addMessage(
//               "bot",
//               result.message ||
//                 "Thank you for your time! We'll get back to you soon. 🎉"
//             );
//             setConversationEnded(true);
//             // ✅ Mark conversation as completed
//             markConversationComplete();
//           }, 800);
//           setCurrentQuestion(null);
//           break;

//         case "next_question":
//         default:
//           // ✅ Also check for external link in next_question responses
//           if (result.externalLink) {
//             console.log(
//               "🔗 Opening external link from next_question:",
//               result.externalLink
//             );
//             window.open(result.externalLink, "_blank", "noopener,noreferrer");
//           }

//           if (result.nextQuestion) {
//             console.log(
//               "➡️ Moving to next question:",
//               result.nextQuestion.text
//             );
//             setCurrentQuestion(result.nextQuestion);

//             setTimeout(() => {
//               if (result.externalLink) {
//                 addMessage(
//                   "bot",
//                   "I've opened the link in a new tab. Meanwhile..."
//                 );
//                 setTimeout(() => {
//                   addMessage("bot", result.nextQuestion.text);
//                 }, 1000);
//               } else {
//                 addMessage("bot", result.nextQuestion.text);
//               }

//               // Handle auto-advance for message types
//               if (
//                 result.nextQuestion.type === "message" &&
//                 result.nextQuestion.messageSettings?.autoAdvance
//               ) {
//                 setTimeout(() => {
//                   handleAutoAdvance(result.nextQuestion);
//                 }, result.nextQuestion.messageSettings.delay || 1500);
//               }
//             }, 800);
//           } else {
//             setTimeout(() => {
//               addMessage(
//                 "bot",
//                 "Thank you for your time! We'll get back to you soon. 🎉"
//               );
//               setConversationEnded(true);
//               // ✅ Mark conversation as completed
//               markConversationComplete();
//             }, 800);
//             setCurrentQuestion(null);
//           }
//           break;
//       }
//     } catch (error) {
//       console.error("❌ Error processing message:", error);
//       addMessage("bot", "Sorry, something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//       processingRef.current = false;
//     }
//   };

//   // ✅ Add helper function to mark conversation as complete
//   const markConversationComplete = async () => {
//     try {
//       console.log("🏁 Marking conversation as complete...");
//       const response = await fetch(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/conversations/complete`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             userId: generateUserId(),
//             uniquePartnerId: widgetConfigs.uniquePartnerId,
//           }),
//         }
//       );

//       if (response.ok) {
//         console.log("✅ Conversation marked as complete");
//       } else {
//         console.warn("⚠️ Failed to mark conversation as complete");
//       }
//     } catch (error) {
//       console.error("❌ Error marking conversation complete:", error);
//     }
//   };

//   const handleInputKeyPress = (e) => {
//     if (e.key === "Enter" && !loading && userInput.trim() && isValid) {
//       handleSendMessage(userInput.trim());
//     }
//   };

//   const handleChoiceClick = (choice) => {
//     if (loading) return;

//     console.log("🎯 Choice clicked:", choice);

//     // ✅ Handle external links directly from choice options
//     if (choice.actionType === "external_link" && choice.actionValue) {
//       console.log("🔗 Opening external link from choice:", choice.actionValue);
//       // Open link immediately
//       window.open(choice.actionValue, "_blank", "noopener,noreferrer");
//     }

//     // Continue with normal message processing
//     handleSendMessage(choice.label);
//   };

//   const goBack = () => {
//     setView("LandingWindow");
//     setActiveIcon("home");
//   };

//   return (
//     <div className="flex flex-col h-full mb-0 mt-0 overflow-hidden">
//       {/* Header  */}
//       <div
//         className="flex items-center justify-start z-10 p-4"
//         style={{
//           background: `linear-gradient(90deg, ${
//             setupDetails?.widgetCustomizations?.secondaryColor || "#2a4dad"
//           } 0%, ${
//             setupDetails?.widgetCustomizations?.primaryColor || "#4C73DE"
//           } 100%)`,
//           borderRadius: "20px 20px 0 0", // Match widget corner radius
//         }}
//       >
//         <button
//           onClick={goBack}
//           className="p-1 h-7 w-7 rounded-md mr-2 text-white hover:bg-white hover:bg-opacity-20 transition-colors"
//         >
//           <ChevronLeftIcon className="h-5 cursor-pointer" />
//         </button>
//         <div className="text-left">
//           <p className="font-bold text-white">AI Assistant</p>
//           <div className="flex items-center justify-start text-sm">
//             <div className="text-white opacity-90">
//               Status: <span>Online</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Messages Container - Same style as Message.jsx */}
//       <div
//         ref={chatContainerRef}
//         className="flex-1 overflow-y-auto p-4 space-y-4 dexkor-scrollbar-hidden-chat"
//       >
//         {messages.map((msg, index) => (
//           <div
//             key={index}
//             className={`flex items-${
//               msg.sender === "Customer" ? "end" : "start"
//             } ${msg.sender === "Customer" ? "justify-end ml-auto" : ""}`}
//           >
//             <div className="block">
//               <div
//                 className={`${
//                   msg.sender === "Customer"
//                     ? "dexkor-customer-message-box"
//                     : "dexkor-agent-message-box"
//                 }`}
//               >
//                 <p
//                   className={`${
//                     msg.sender === "Customer"
//                       ? "dexkor-customer-message-text"
//                       : "dexkor-agent-message-text"
//                   }`}
//                 >
//                   {msg.message}
//                 </p>
//               </div>
//               <p
//                 className={`${
//                   msg.sender === "Customer"
//                     ? "dexkor-customer-timestamp"
//                     : "dexkor-agent-timestamp"
//                 }`}
//               >
//                 {new Date(msg.timestamp).toLocaleTimeString([], {
//                   hour: "2-digit",
//                   minute: "2-digit",
//                   hour12: true,
//                 })}
//               </p>
//             </div>
//           </div>
//         ))}

//         {/* Loading indicator */}
//         {loading && (
//           <div className="flex items-start">
//             <div className="dexkor-agent-message-box">
//               <div className="flex space-x-1 p-2">
//                 <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
//                 <div
//                   className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
//                   style={{ animationDelay: "0.1s" }}
//                 ></div>
//                 <div
//                   className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
//                   style={{ animationDelay: "0.2s" }}
//                 ></div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Input Area - Same style as Message.jsx */}
//       {!conversationEnded && currentQuestion && (
//         <div
//           className="dexkor-message-input-container p-0 border-gray-200 rounded-lg"
//           style={{
//             border: `1px solid ${
//               setupDetails?.widgetCustomizations.primaryColor || "#4C73DE"
//             }`,
//           }}
//         >
//           {/* Choice Questions - Show buttons */}
//           {currentQuestion.type === "choice" && currentQuestion.options && (
//             <div className="p-3 space-y-2">
//               {currentQuestion.options.map((choice, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handleChoiceClick(choice)}
//                   disabled={loading}
//                   className="w-full p-3 text-left bg-gray-100 hover:bg-gray-200 rounded-lg transition disabled:opacity-50 text-sm"
//                   style={{
//                     borderLeft: `4px solid ${
//                       setupDetails?.widgetCustomizations.primaryColor ||
//                       "#4C73DE"
//                     }`,
//                   }}
//                 >
//                   {choice.label}
//                 </button>
//               ))}
//             </div>
//           )}

//           {/* Text Input Questions - Same as Auto-Advance Style */}
//           {/* Text Input Questions - Fixed positioning */}
//           {(currentQuestion.type === "data_collection" ||
//             currentQuestion.type === "text") && (
//             <div className="px-4 py-4 relative">
//               <div
//                 className="relative rounded-full border bg-white w-full max-w-md mx-auto"
//                 style={{
//                   border: "1px solid #d1d5db",
//                 }}
//               >
//                 <input
//                   placeholder={
//                     currentQuestion.dataCollection?.placeholder ||
//                     "Ask me anything"
//                   }
//                   value={userInput}
//                   onChange={(e) => handleInputChange(e.target.value)}
//                   onKeyPress={handleInputKeyPress}
//                   disabled={loading}
//                   className="w-full py-2 px-4 pr-12 rounded-full border-none text-sm focus:outline-none bg-transparent"
//                   style={{
//                     fontSize: "14px",
//                     color: "#9ca3af",
//                     fontWeight: "400",
//                   }}
//                 />

//                 <button
//                   onClick={() => handleSendMessage(userInput.trim())}
//                   disabled={!userInput.trim() || loading || !isValid}
//                   className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white rounded-full disabled:opacity-50 flex items-center justify-center"
//                   style={{
//                     background:
//                       setupDetails?.widgetCustomizations.primaryColor ||
//                       "#8b5cf6",
//                     width: "32px",
//                     height: "32px",
//                   }}
//                 >
//                   <PaperAirplaneIcon className="h-4 w-4" />
//                 </button>
//               </div>

//               {/* Fixed validation error positioning */}
//               {validationError && (
//                 <div className="text-red-500 text-xs mt-2 text-center">
//                   ⚠️ {validationError}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Message Questions - Auto-advance */}
//           {currentQuestion.type === "message" && (
//             <div className="p-3 text-center text-gray-500 text-sm">
//               {currentQuestion.messageSettings?.autoAdvance
//                 ? "Message will auto-advance..."
//                 : "Processing..."}
//             </div>
//           )}
//         </div>
//       )}
//       {/* Conversation Ended */}
//       {conversationEnded && (
//         <div className="p-4 text-center border-t border-gray-200">
//           <p className="text-gray-600 mb-3">
//             Thanks for chatting with our AI assistant!
//           </p>
//           <button
//             onClick={goBack}
//             className="px-4 py-2 text-white rounded-lg"
//             style={{
//               background:
//                 setupDetails?.widgetCustomizations.primaryColor || "#4C73DE",
//             }}
//           >
//             Back to Menu
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AutomatedBot;

// +++++++++++++++++++++++++++++++++++++++++++++++++LEGACY+++++++++++++++++++++++++++++++++++++++++

import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import {
  CameraIcon,
  MicrophoneIcon,
  PaperAirplaneIcon,
  PaperClipIcon,
  VideoCameraIcon,
} from "@heroicons/react/24/outline";
import { ChevronLeft, X, Bot, ChevronRight } from "lucide-react";
import { RiSpeakLine } from "react-icons/ri";
import html2canvas from "html2canvas";
import DOMPurify from "dompurify";
import axios from "axios";
import "../CSS/Message.css";
import "../CSS/CustomerChat.css";
import { useSelector, useDispatch } from "react-redux";
import { getSocket } from "../utils/useChatSocket";
import { createConvo, setConvo } from "../Redux/Actions/convoActions";
import {
  getValidChatSession,
  saveChatSession,
  getAutomatedHistory,
  saveAutomatedHistory,
} from "../utils/sessionManager";
import RenderAttachment from "./attachmentRenders/RenderAttachment";
import { getAgentInfoById, getCachedAgentInfo } from "../utils/agentService";
import FeedbackForm from "./FeedbackForm";
import Feedback from "./Feedback";
import { getFallbackBackView } from "../utils/navigationHelper";

const socket = getSocket();

// Utility functions
const generateUserId = () => {
  let userId = localStorage.getItem("chatbot_user_id");
  if (!userId) {
    userId = "user_" + Math.random().toString(36).substr(2, 9);
    localStorage.setItem("chatbot_user_id", userId);
  }
  return userId;
};

// Clean HTML template spacers, email tracking divs, and empty lines
const cleanAndSanitizeMessage = (rawMessage) => {
  if (!rawMessage || typeof rawMessage !== "string") return "";

  let content = rawMessage.trim();

  // 1. Remove HTML comments
  content = content.replace(/<!--[\s\S]*?-->/g, "");

  // 2. Remove hidden tracking/spacer divs completely
  content = content.replace(
    /<div[^>]*?(?:display:\s*none|font:\s*15px courier)[^>]*?>[\s\S]*?<\/div>/gi,
    ""
  );

  // 3. Detect if it contains HTML tags
  const hasHtml = /<\/?[a-z][\s\S]*>/i.test(content);

  if (hasHtml) {
    // Clean up excessive whitespace/newlines between tags
    content = content.replace(/>\s*\n+\s*</g, "><");

    // Remove redundant wrapper div if it just sets font-family
    content = content.replace(
      /^<div style="font-family:[^>]*>([\s\S]*)<\/div>$/i,
      "$1"
    );

    // Sanitize with DOMPurify
    const sanitized = DOMPurify.sanitize(content, {
      ALLOWED_TAGS: [
        "b", "i", "em", "strong", "a", "p", "br", "ul", "ol", "li", "span", "div",
        "code", "pre", "blockquote", "img"
      ],
      ALLOWED_ATTR: ["href", "target", "rel", "src", "alt", "class", "style"],
    });

    // Strip trailing empty <p></p>, <br>, or &nbsp;
    return sanitized
      .replace(/(?:<p>\s*(?:<br\s*\/?>|&nbsp;|\s)*<\/p>|<br\s*\/?>|\s|&nbsp;)+$/gi, "")
      .trim();
  }

  // Plain text: convert newlines to <br> and sanitize
  const withBreaks = content.replace(/\n/g, "<br>");
  return DOMPurify.sanitize(withBreaks);
};

const getInitials = (name) => {
  if (!name) return "A";
  const clean = name.replace(/@.*$/, "").trim();
  const parts = clean.split(/[.\s_-]+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  if (parts.length === 1 && parts[0].length >= 1) {
    return parts[0][0].toUpperCase();
  }
  return (clean[0] || "A").toUpperCase();
};

const formatSenderName = (name) => {
  if (!name) return "Support Agent";
  const clean = name.replace(/@.*$/, "").trim();
  const parts = clean.split(/[.\s_-]+/).filter(Boolean);
  if (parts.length > 0) {
    return parts
      .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
      .join(" ");
  }
  return "Support Agent";
};

// Gleap-style Dexy Bot Avatar: black circle with 3 horizontal white dots
const DexyBotIcon = ({ className = "w-5 h-5", dotClass = "w-1 h-1", gap = "gap-[2px]" }) => (
  <div className={`${className} rounded-full bg-black flex items-center justify-center text-white shrink-0 shadow-sm`}>
    <div className={`flex items-center ${gap}`}>
      <div className={`${dotClass} rounded-full bg-white`} />
      <div className={`${dotClass} rounded-full bg-white`} />
      <div className={`${dotClass} rounded-full bg-white`} />
    </div>
  </div>
);

const resolveAgentDetails = (msg, setupDetails, convo) => {
  const isAutomatedSender = msg?.isBot === true || msg?.isAutomated === true
    || msg?.sender === "Chatbot"
    || ["workflow", "dexy_ai"].includes(msg?.metadata?.source)
    || ["Workflow", "Dexy AI"].includes(msg?.fromAddress);
  if (isAutomatedSender) {
    const isDexy = setupDetails?.widgetWorkflow?.workflowId === "dexy_ai"
      || msg?.metadata?.source === "dexy_ai"
      || msg?.fromAddress === "Dexy AI";
    if (isDexy) {
      return {
        isBot: true,
        isDexy: true,
        name: setupDetails?.widgetCustomizations?.aiBotName || "Dexy",
        avatar: setupDetails?.widgetCustomizations?.botAvatar || null,
        initials: "D",
      };
    }
    const isBuilder = !['legacy', 'dexy_ai'].includes(setupDetails?.widgetWorkflow?.workflowId);
    return {
      isBot: true,
      isDexy: false,
      name: isBuilder ? "Dexy Bot" : (setupDetails?.widgetCustomizations?.botName || "Support Bot"),
      avatar: setupDetails?.widgetCustomizations?.botAvatar || null,
      initials: isBuilder ? "D" : "B",
    };
  }
  const cached = msg?.senderId ? getCachedAgentInfo(msg.senderId) : null;
  const rawName =
    cached?.name ||
    msg.user?.name ||
    msg.agentName ||
    msg.senderName ||
    (msg.fromAddress ? msg.fromAddress.split("@")[0] : "") ||
    convo?.agent?.name ||
    convo?.assignedTo?.name ||
    setupDetails?.agent?.name ||
    setupDetails?.widgetCustomizations?.agentName ||
    "Support Agent";

  const rawAvatar =
    cached?.avatar ||
    msg.avatar ||
    msg.user?.avatar ||
    msg.user?.image ||
    msg.user?.profilePic ||
    msg.user?.profileImage ||
    msg.agent?.avatar ||
    msg.agentAvatar ||
    convo?.agent?.avatar ||
    convo?.assignedTo?.avatar ||
    setupDetails?.agent?.avatar ||
    setupDetails?.widgetCustomizations?.botAvatar ||
    setupDetails?.widgetCustomizations?.avatar ||
    null;

  return {
    name: formatSenderName(rawName),
    avatar: rawAvatar,
    initials: cached?.initials || getInitials(rawName),
  };
};

// Helper to determine if two message objects are identical
const areMessagesEquivalent = (m1, m2) => {
  if (!m1 || !m2) return false;
  if (m1._id && m2._id && m1._id === m2._id) return true;
  if (m1.localId && m2.localId && m1.localId === m2.localId) return true;
  if (m1.requestId && m2.requestId && m1.requestId === m2.requestId) return true;
  if (m1.clientMessageId && m2.clientMessageId && m1.clientMessageId === m2.clientMessageId) return true;

  if (m1.sender === m2.sender) {
    const c1 = (cleanAndSanitizeMessage(m1.message || "") || (m1.attachment || "")).trim();
    const c2 = (cleanAndSanitizeMessage(m2.message || "") || (m2.attachment || "")).trim();
    if (c1 && c2 && c1 === c2) {
      const t1 = m1.timestamp ? new Date(m1.timestamp).getTime() : 0;
      const t2 = m2.timestamp ? new Date(m2.timestamp).getTime() : 0;
      if (Math.abs(t1 - t2) < 10000 || !t1 || !t2) return true;
    }
  }
  return false;
};

const AutomatedBot = ({
  setView,
  setupDetails,
  widgetConfigs,
  setActiveIcon,
  setIsOpen,
  conversations,
  initialMessage,
  onMessageConsumed,
}) => {
  const dispatch = useDispatch();
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [loading, setLoading] = useState(false);
  const [botTyping, setBotTyping] = useState(false);
  const [initializationError, setInitializationError] = useState(false);
  useEffect(() => {
    if (!botTyping) return;
    // Clear abandoned requests if the server or connection fails without a response.
    const timeout = setTimeout(() => setBotTyping(false), 90000);
    return () => clearTimeout(timeout);
  }, [botTyping]);
  const [conversationEnded, setConversationEnded] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [initialized, setInitialized] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [localMessages, setLocalMessages] = useState([]);
  const [botCompleted, setBotCompleted] = useState(false);
  const chatContainerRef = useRef(null);
  const processingRef = useRef(false);
  const creatingConvoRef = useRef(false);
  const initialMessageSentRef = useRef(false);
  const tempRoomIdRef = useRef(`TempRoom-${generateUserId()}`);
  const fileInputRef = useRef(null);
  const [attachment, setAttachment] = useState(null);
  const [attachmentType, setAttachmentType] = useState(null);
  const [uploadingAttachment, setUploadingAttachment] = useState(false);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const [recording, setRecording] = useState(false);
  const [transcribing, setTranscribing] = useState(false);
  const recognitionRef = useRef(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const timerIntervalRef = useRef(null);
  const [isScreenRecording, setIsScreenRecording] = useState(false);
  const emittedToSocketRef = useRef(new Set());

  // Get room from Redux convo
  const convo = useSelector((state) => state.convo);

  const [availableAgents, setAvailableAgents] = useState([]);
  const [agentProfiles, setAgentProfiles] = useState({});

  const [feedbackState, setFeedbackState] = useState({});
  const [thinkingStage, setThinkingStage] = useState(0);
  const [streamingMessageId, setStreamingMessageId] = useState(null);
  const [streamedTextMap, setStreamedTextMap] = useState({});
  const activeIntervalRef = useRef(null);

  // Cycle thinking stage when botTyping is active (Thinking... -> Gathering information...)
  useEffect(() => {
    let timer = null;
    if (botTyping) {
      setThinkingStage(0);
      timer = setTimeout(() => {
        setThinkingStage(1);
      }, 1500);
    } else {
      setThinkingStage(0);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [botTyping]);

  // Handle message CSAT feedback rating
  const handleFeedback = async (msgId, rating) => {
    if (!msgId) return;
    setFeedbackState((prev) => ({ ...prev, [msgId]: rating }));

    try {
      const chatUrl = process.env.REACT_APP_CHAT_MICROSERVICE_URL;
      const partnerId =
        widgetConfigs?.uniquePartnerId ||
        localStorage.getItem("uniquePartnerId") ||
        localStorage.getItem("partner_id");

      let storedCustomer = {};
      try {
        storedCustomer =
          JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details")) || {};
      } catch (e) {}

      const ticketNum =
        convo?.ticketId?.ticketNumber ||
        convo?.ticketNumber ||
        null;

      await axios.post(`${chatUrl}/conversations/message-csat`, {
        messageId: String(msgId),
        rating,
        roomId: convo?.roomId,
        conversationId: convo?._id,
        ticketNumber: ticketNum,
        ticketId: convo?.ticketId?._id || convo?.ticketId || undefined,
        uniquePartnerId: partnerId,
        customerId: storedCustomer?._id || widgetConfigs?.userId,
        userEmail: storedCustomer?.email || widgetConfigs?.userEmail || widgetConfigs?.email,
        userNumber: storedCustomer?.phone || widgetConfigs?.userNumber,
      });
    } catch (err) {
      console.warn("Message CSAT save note:", err.message);
    }
  };

  // Fetch message CSAT ratings on mount for active room
  useEffect(() => {
    if (!convo?.roomId) return;
    const chatUrl = process.env.REACT_APP_CHAT_MICROSERVICE_URL;
    // Fetch per-message CSAT
    axios
      .get(`${chatUrl}/conversations/message-csat/${convo.roomId}`)
      .then((res) => {
        if (res.data?.success && Array.isArray(res.data.data)) {
          const stateMap = {};
          res.data.data.forEach((item) => {
            if (item.messageId && item.rating) {
              stateMap[item.messageId] = item.rating;
            }
          });
          setFeedbackState((prev) => ({ ...prev, ...stateMap }));
        }
      })
      .catch((err) => {
        console.log("Message CSAT fetch note:", err.message);
      });
  }, [convo?.roomId]);

  const uiColor =
    setupDetails?.widgetCustomizations?.uiColor ||
    setupDetails?.widgetCustomizations?.color1 ||
    setupDetails?.widgetCustomizations?.primaryColor ||
    "#1C243A";

  const brandName =
    setupDetails?.partnerDetails?.brandName ||
    setupDetails?.widgetCustomizations?.partnerName ||
    "";

  // Fetch real available active agents from auth microservice (for 3 overlapping active agents header display)
  useEffect(() => {
    const partnerId =
      widgetConfigs?.uniquePartnerId ||
      localStorage.getItem("uniquePartnerId") ||
      localStorage.getItem("partner_id") ||
      "66f7d1662ea86574e070c536";

    if (!partnerId) return;

    const fetchAgents = async () => {
      try {
        const authUrl =
          process.env.REACT_APP_AUTH_MICROSERVICE_URL ||
          "https://auth-stg.dexkor.com/api/v1";
        const res = await axios.get(`${authUrl}/users/all/${partnerId}`);
        if (Array.isArray(res.data) && res.data.length > 0) {
          const activeUsers = res.data.filter((u) => {
            const availStatus = u?.availabilityStatus?.status;
            const isAvailActive = availStatus === "Active";
            const isAccountActive = u?.status === "Active" || !u?.status;
            const isAvailable = u?.available !== false;
            const hasName = Boolean(u?.name && u.name.trim());
            return isAvailActive && isAccountActive && isAvailable && hasName;
          });

          const seenNames = new Set();
          const uniqueActive = [];
          activeUsers.forEach((u) => {
            const cleanName = u.name.replace(/\(.*?\)/g, "").trim().toLowerCase();
            if (!seenNames.has(cleanName)) {
              seenNames.add(cleanName);
              uniqueActive.push(u);
            }
          });

          const sorted = [...uniqueActive].sort((a, b) => {
            const aImg = Boolean(a.image || a.profilePic || a.profilePicture || a.avatar);
            const bImg = Boolean(b.image || b.profilePic || b.profilePicture || b.avatar);
            if (aImg && !bImg) return -1;
            if (!aImg && bImg) return 1;
            return 0;
          });

          const mapped = sorted.slice(0, 3).map((u) => ({
            id: u._id,
            name: u.name,
            avatar: u.image || u.profilePic || u.profilePicture || u.avatar || null,
            initials: u.name
              .split(" ")
              .filter(Boolean)
              .map((p) => p[0])
              .join("")
              .toUpperCase()
              .substring(0, 2),
          }));

          if (mapped.length > 0) {
            setAvailableAgents(mapped);
          }
        }
      } catch (err) {
        console.log("Agents fetch note:", err.message);
      }
    };

    fetchAgents();
  }, [widgetConfigs?.uniquePartnerId]);

  const workflowEnabled = setupDetails?.widgetWorkflow?.enabled === true;
  const legacyWorkflow = workflowEnabled && setupDetails?.widgetWorkflow?.workflowId === 'legacy' && convo?.botHandled !== 'handed_off';
  const dexyEnabled = setupDetails?.widgetWorkflow?.explicitlyDisabled !== true && (!workflowEnabled || setupDetails?.widgetWorkflow?.workflowId === 'dexy_ai') && setupDetails?.widgetAiEnabled === true;
  const dexyActive = dexyEnabled && convo?.botHandled !== "handed_off";
  useEffect(() => {
    if (convo?.botHandled === 'handed_off') setBotTyping(false);
  }, [convo?.botHandled]);
  const builderWorkflowActive = workflowEnabled && !['legacy', 'dexy_ai'].includes(setupDetails?.widgetWorkflow?.workflowId) && convo?.botHandled !== "handed_off";
  const isBuilderMode = workflowEnabled && !['legacy', 'dexy_ai'].includes(setupDetails?.widgetWorkflow?.workflowId);
  const startedBuilderRef = useRef(null);

  const getActiveRoomId = () => {
    if (convo?.roomId) return convo.roomId;
    const session = getValidChatSession(widgetConfigs?.uniquePartnerId, setupDetails?.widgetWorkflow?.workflowId);
    if (session && session.roomId) return session.roomId;
    return null;
  };

  const flushAutomatedHistoryToSocket = (roomId) => {
    if (!socket || !roomId) return;
    if (localStorage.getItem(`dexkor_flushed_${roomId}`) === "true") {
      return;
    }
    localStorage.setItem(`dexkor_flushed_${roomId}`, "true");

    const historyToFlush = automatedHistory.length > 0 ? automatedHistory : localMessages;
    historyToFlush.forEach((msg) => {
      const key = msg.localId || msg.message;
      if (msg.message && !emittedToSocketRef.current.has(key)) {
        emittedToSocketRef.current.add(key);
        socket.emit("message", {
          room: roomId,
          sender: msg.sender || "Customer",
          senderId: msg.senderId || "",
          isBot: msg.isBot === true || msg.sender === "Agent",
          metadata: msg.metadata || (msg.sender === "Agent" ? { source: "workflow" } : {}),
          message: msg.message,
          attachment: msg.attachment || null,
          attachmentType: msg.attachmentType || null,
          uniquePartnerId: widgetConfigs?.uniquePartnerId,
          timestamp: msg.timestamp || new Date().toISOString(),
        });
      }
    });
  };

  // Check if bot conversation was already completed in this 24-hour session
  const [botConversationCompleted, setBotConversationCompleted] = useState(
    () => {
      const activeSession = getValidChatSession(widgetConfigs?.uniquePartnerId);
      if (activeSession && activeSession.botCompleted === true) return true;
      if (convo?.roomId && localStorage.getItem(`bot_completed_${convo.roomId}`) === "true") {
        return true;
      }
      return false;
    }
  );

  const saveBotProgress = (question, messages, autoHistory) => {
    if (!widgetConfigs?.uniquePartnerId) return;
    try {
      const key = `dexkor_bot_progress_${widgetConfigs.uniquePartnerId}`;
      localStorage.setItem(
        key,
        JSON.stringify({
          currentQuestion: question,
          localMessages: messages || [],
          automatedHistory: autoHistory || [],
          timestamp: Date.now(),
        })
      );
    } catch (e) { }
  };

  const clearBotProgress = () => {
    if (!widgetConfigs?.uniquePartnerId) return;
    try {
      localStorage.removeItem(`dexkor_bot_progress_${widgetConfigs.uniquePartnerId}`);
    } catch (e) { }
  };

  // Automated Chat History state (persisted across sessions/tabs)
  const [automatedHistory, setAutomatedHistory] = useState(() => {
    return getAutomatedHistory(widgetConfigs?.uniquePartnerId);
  });

  // API Fetch for thread messages using roomId (from session or Redux)
  const fetchLiveChatMessages = useCallback(async () => {
    const roomId = convo?.roomId || getActiveRoomId();
    if (!roomId) return;

    try {
      let data = null;
      try {
        const url = `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/conversations/room/${roomId}`;
        const res = await axios.get(url);
        if (res.data?.success && Array.isArray(res.data.messages)) {
          data = res.data;
        }
      } catch (e1) {
        try {
          const fallbackUrl = `http://localhost:8000/api/v1/conversations/room/${roomId}`;
          const res2 = await axios.get(fallbackUrl);
          if (res2.data?.success && Array.isArray(res2.data.messages)) {
            data = res2.data;
          }
        } catch (e2) { }
      }

      if (data && Array.isArray(data.messages) && data.messages.length > 0) {
        console.log("📥 Fetched thread messages via API for room:", roomId, data.messages.length);

        setLocalMessages((prev) => {
          const merged = [...prev];
          data.messages.forEach((msg) => {
            const exists = merged.some((m) => areMessagesEquivalent(m, msg));
            if (!exists) merged.push(msg);
          });
          return merged;
        });

        if (data.conversation) {
          dispatch(
            setConvo({
              ...data.conversation,
              messages: data.messages,
              workflowId: setupDetails?.widgetWorkflow?.workflowId || convo?.workflowId || null,
            })
          );
        }

        const activeSession = getValidChatSession(widgetConfigs?.uniquePartnerId, setupDetails?.widgetWorkflow?.workflowId);
        if (activeSession) {
          saveChatSession(widgetConfigs?.uniquePartnerId, {
            ...activeSession,
            roomId: roomId,
            conversation: {
              ...(activeSession.conversation || {}),
              ...(data.conversation || {}),
              messages: data.messages,
            },
          });
        }
      }
    } catch (err) {
      console.error("Error fetching live chat messages:", err);
    }
  }, [convo?.roomId, widgetConfigs?.uniquePartnerId, dispatch]);

  // Fetch thread messages from API on mount and whenever roomId becomes active
  useEffect(() => {
    fetchLiveChatMessages();
  }, [fetchLiveChatMessages]);

  // Hydrate local messages from convo history if available
  useEffect(() => {
    if (convo && Array.isArray(convo.messages) && convo.messages.length > 0) {
      setLocalMessages((prev) => {
        const merged = [...prev];
        convo.messages.forEach((msg) => {
          const exists = merged.some((m) => areMessagesEquivalent(m, msg));
          if (!exists) merged.push(msg);
        });
        return merged;
      });
    }
  }, [convo]);

  // Sync messages from conversations prop (updated in ChatWindow on socket events)
  useEffect(() => {
    const activeRoom = convo?.roomId || getActiveRoomId();
    if (!activeRoom || !Array.isArray(conversations)) return;
    const matchingConv = conversations.find((c) => c.roomId === activeRoom);
    if (matchingConv && Array.isArray(matchingConv.messages) && matchingConv.messages.length > 0) {
      setLocalMessages((prev) => {
        const merged = [...prev];
        matchingConv.messages.forEach((msg) => {
          const exists = merged.some((m) => areMessagesEquivalent(m, msg));
          if (!exists) merged.push(msg);
        });
        return merged;
      });
    }
  }, [conversations, convo?.roomId]);


  // Track processed message IDs to prevent duplicates
  const processedMessageIdsRef = useRef(new Set());

  const genLocalId = () =>
    `loc-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

  // Helper to mark message as processed
  const markProcessed = (id) => {
    if (!id) return;
    processedMessageIdsRef.current.add(id);
  };

  // Helper to check if message was processed
  const isProcessed = (id) => {
    if (!id) return false;
    return processedMessageIdsRef.current.has(id);
  };

  // Build a signature without timestamp for robust de-duplication
  const buildSignatureNoTs = (sender, senderId, message) =>
    `${sender || "s"}_${senderId || ""}_${message || ""}`;

  // Get all unique messages without duplicates
  const getDisplayMessages = () => {
    const activeRoom = convo?.roomId || getActiveRoomId();
    const matchingConv = Array.isArray(conversations)
      ? conversations.find((c) => c.roomId === activeRoom)
      : null;
    const all = [
      ...(matchingConv?.messages || []),
      ...(convo?.messages || []),
      ...localMessages,
    ];
    const unique = [];

    for (const msg of all) {
      if (!msg) continue;
      const hasAttachment = Boolean(
        msg.attachment ||
        (Array.isArray(msg.attachments) && msg.attachments.length > 0)
      );
      const hasMessage = Boolean(
        msg.message &&
        typeof msg.message === "string" &&
        msg.message.trim().length > 0
      );
      if (!hasAttachment && !hasMessage) continue;

      const isDup = unique.some((existing) => areMessagesEquivalent(existing, msg));
      if (!isDup) {
        unique.push(msg);
      } else {
        // If the duplicate has _id but existing does not, upgrade it
        const idx = unique.findIndex((existing) => areMessagesEquivalent(existing, msg));
        if (idx !== -1 && msg._id && !unique[idx]._id) {
          unique[idx] = { ...unique[idx], ...msg };
        }
      }
    }
    return unique.sort(
      (a, b) => new Date(a.timestamp || 0) - new Date(b.timestamp || 0)
    );
  };

  const displayMessages = getDisplayMessages();

  // Separate live messages from automated history so there are no duplicates
  const liveMessages = displayMessages.filter((msg) => {
    if (!legacyWorkflow) return true;
    if (msg.isAutomated) return false;
    const isDup = automatedHistory.some(
      (a) =>
        (a.localId && msg.localId && a.localId === msg.localId) ||
        (a.sender === msg.sender &&
          Boolean(msg.message && a.message) &&
          a.message?.trim() === msg.message?.trim())
    );
    return !isDup;
  });

  // Compute active agent details for handoff header.
  // Returns null when no agent has actually sent a message yet (waiting state).
  const activeAgent = useMemo(() => {
    // Priority 1: agent who last sent a message with a known senderId
    const lastAgentMsg = [...liveMessages].reverse().find((m) => m.sender === "Agent" && m.senderId);
    if (lastAgentMsg?.senderId) {
      const id = String(lastAgentMsg.senderId);
      const profile = agentProfiles[id] || getCachedAgentInfo(id);
      if (profile) return profile;
    }

    // Priority 2: agent message with a display name (but no profile id)
    const anyAgentMsg = [...liveMessages].reverse().find((m) => m.sender === "Agent" && (m.fromAddress || m.senderName));
    if (anyAgentMsg) {
      const name = anyAgentMsg.senderName || anyAgentMsg.fromAddress || "Support Agent";
      return {
        id: anyAgentMsg.senderId || "agent",
        name,
        avatar: null,
        initials: name.charAt(0).toUpperCase(),
      };
    }

    // No agent has replied yet — return null to show the "waiting" state
    return null;
  }, [liveMessages, agentProfiles]);

  // Resolve agent profile details from auth microservice for any agent messages
  useEffect(() => {
    displayMessages.forEach((m) => {
      if (m.sender !== "Customer" && m.senderId && !getCachedAgentInfo(m.senderId)) {
        getAgentInfoById(m.senderId).then(() => {
          setLocalMessages((prev) => [...prev]);
        });
      }
    });
  }, [displayMessages, botTyping]);

  // Validation function
  const validateInput = (input, currentQuestion) => {
    if (!currentQuestion || !currentQuestion.dataCollection) {
      return { isValid: true, error: "" };
    }

    const { dataCollection } = currentQuestion;

    // Required field check
    if (dataCollection.isRequired && (!input || input.trim().length === 0)) {
      return { isValid: false, error: "This field is required" };
    }

    if (!input || input.trim().length === 0) {
      return { isValid: true, error: "" };
    }

    // Length validation
    if (
      dataCollection.validation?.minLength &&
      input.length < dataCollection.validation.minLength
    ) {
      return {
        isValid: false,
        error: `Minimum ${dataCollection.validation.minLength} characters required`,
      };
    }

    if (
      dataCollection.validation?.maxLength &&
      input.length > dataCollection.validation.maxLength
    ) {
      return {
        isValid: false,
        error: `Maximum ${dataCollection.validation.maxLength} characters allowed`,
      };
    }

    // Data type validation
    switch (dataCollection.dataType) {
      case "email":
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(input)) {
          return {
            isValid: false,
            error: "Please enter a valid email address",
          };
        }
        break;

      case "phone":
        const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
        const cleanPhone = input.replace(/[\s\-\(\)]/g, "");
        if (!phoneRegex.test(cleanPhone)) {
          return { isValid: false, error: "Please enter a valid phone number" };
        }
        break;

      case "number":
        if (isNaN(Number(input))) {
          return { isValid: false, error: "Please enter a valid number" };
        }
        break;

      case "url":
        try {
          new URL(input);
        } catch {
          return { isValid: false, error: "Please enter a valid URL" };
        }
        break;

      case "name":
        const nameRegex = /^[a-zA-Z\s]{2,50}$/;
        if (!nameRegex.test(input)) {
          return {
            isValid: false,
            error: "Please enter a valid name (2-50 characters, letters only)",
          };
        }
        break;
    }

    // Custom pattern validation
    if (dataCollection.validation?.pattern) {
      const customRegex = new RegExp(dataCollection.validation.pattern);
      if (!customRegex.test(input)) {
        return {
          isValid: false,
          error:
            dataCollection.validation.errorMessage || "Invalid input format",
        };
      }
    }

    return { isValid: true, error: "" };
  };

  // Input change handler with validation
  const handleInputChange = (value) => {
    setUserInput(value);

    if (currentQuestion && currentQuestion.type === "data_collection") {
      const validation = validateInput(value, currentQuestion);
      setIsValid(validation.isValid);
      setValidationError(validation.error);
    } else {
      setIsValid(true);
      setValidationError("");
    }
  };

  // Clear validation when question changes
  useEffect(() => {
    setValidationError("");
    setIsValid(true);
    setUserInput("");
  }, [currentQuestion]);

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [displayMessages]);

  const prevRoomIdRef = useRef(null);

  // When convo.roomId becomes available from background ticket creation, flush any messages that were sent in the interim
  useEffect(() => {
    if (convo?.roomId && convo.roomId !== prevRoomIdRef.current) {
      prevRoomIdRef.current = convo.roomId;
      if (legacyWorkflow) flushAutomatedHistoryToSocket(convo.roomId);
    }
  }, [convo?.roomId, legacyWorkflow]);

  // Initialize chat when component mounts - starts bot immediately while ticket creates in background!
  useEffect(() => {
    // Wait until setupDetails is loaded to know the true workflow mode
    if (!setupDetails) return;

    const currentWorkflowId = setupDetails?.widgetWorkflow?.workflowId || 'legacy';
    const isBuilderMode = workflowEnabled && !['legacy', 'dexy_ai'].includes(currentWorkflowId);

    // If Redux convo belongs to a different workflow, reset to create fresh convo
    if (convo?.roomId && convo.workflowId && convo.workflowId !== currentWorkflowId) {
      dispatch(setConvo({}));
      return;
    }

    // 1. Kick off ticket creation in the background if not already started
    if (!convo?.roomId && widgetConfigs?.uniquePartnerId && !creatingConvoRef.current) {
      creatingConvoRef.current = true;
      setInitializationError(false);
      dispatch(createConvo(widgetConfigs, { 
        automated: workflowEnabled || dexyEnabled,
        workflowId: currentWorkflowId,
      }))
        .then(result => { if (!result?.roomId) setInitializationError(true); })
        .catch(() => setInitializationError(true))
        .finally(() => { creatingConvoRef.current = false; });
    }

    // Dexy & Builder flows use their respective engines; never start legacy workflow questions.
    if (!legacyWorkflow) {
      setCurrentQuestion(null);
      setInitialized(true);
      if (builderWorkflowActive && convo?.roomId) {
        const startKey = `${convo.roomId}:${currentWorkflowId}`;
        if (startedBuilderRef.current !== startKey) {
          startedBuilderRef.current = startKey;
          setBotTyping(true);
          socket.emit('widget:startWorkflow', { roomId: convo.roomId, uniquePartnerId: widgetConfigs.uniquePartnerId, supportsButtons: true });
        }
      }
      return;
    }

    // 2. Check if bot conversation was already completed
    const activeSession = getValidChatSession(widgetConfigs?.uniquePartnerId);
    if (
      botConversationCompleted ||
      (activeSession && activeSession.botCompleted === true) ||
      (convo?.roomId && localStorage.getItem(`bot_completed_${convo.roomId}`) === "true")
    ) {
      setBotCompleted(true);
      setBotConversationCompleted(true);
      setInitialized(true);
      return;
    }

    // 3. Immediately start bot questions without waiting 5-10s for ticket creation!
    if (!initialized && !processingRef.current) {
      initializeChat();
    }
  }, [convo?.roomId, convo?.botHandled, initialized, botConversationCompleted, widgetConfigs?.uniquePartnerId, dexyEnabled, legacyWorkflow, builderWorkflowActive, workflowEnabled, setupDetails?.widgetWorkflow?.workflowId]);

  const initializeChat = async () => {
    if (!legacyWorkflow) return;
    if (processingRef.current) return;
    processingRef.current = true;

    try {
      setLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/start?uniquePartnerId=${widgetConfigs.uniquePartnerId}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const firstQuestion = await response.json();

      setCurrentQuestion(firstQuestion);
      setInitialized(true);
      saveBotProgress(firstQuestion, [], []);

      // Show the greeting as soon as it is available.
      sendBotMessage(firstQuestion.text);

      // Preserve configured auto-advance timing.
      if (
        firstQuestion.type === "message" &&
        firstQuestion.messageSettings?.autoAdvance
      ) {
        setTimeout(() => {
          handleAutoAdvance(firstQuestion);
        }, firstQuestion.messageSettings.delay || 1500);
      }
    } catch (error) {
      console.error("❌ Failed to initialize automated chat:", error);
      // Do NOT connect to live agent on initialization error
    } finally {
      setLoading(false);
      processingRef.current = false;
    }
  };

  const sendBotMessage = (messageText) => {
    const activeRoom = getActiveRoomId();
    const roomIdToUse = activeRoom || tempRoomIdRef.current;
    const localId = genLocalId();

    const botMessage = {
      localId,
      room: roomIdToUse,
      sender: "Agent",
      senderId: "",
      isBot: true,
      metadata: { source: "workflow" },
      message: messageText,
      attachment: null,
      attachmentType: null,
      uniquePartnerId: widgetConfigs?.uniquePartnerId,
      timestamp: new Date().toISOString(),
    };

    console.log("🤖 Sending bot message:", botMessage);

    // Mark processed so server echo won't duplicate (localId + content signature)
    markProcessed(localId);
    const contentSignature = `${botMessage.sender}_${botMessage.senderId}_${botMessage.timestamp}_${botMessage.message}`;
    markProcessed(contentSignature);
    const contentSignatureNoTs = buildSignatureNoTs(
      botMessage.sender,
      botMessage.senderId,
      botMessage.message
    );
    markProcessed(contentSignatureNoTs);

    // If bot is active, also record into automated history
    if (!botCompleted && !botConversationCompleted) {
      setAutomatedHistory((prev) => {
        const next = [...prev, botMessage];
        saveAutomatedHistory(widgetConfigs?.uniquePartnerId, next);
        return next;
      });
    }

    // Add to local messages for immediate display
    setLocalMessages((prev) => {
      const exists = prev.some((m) => m.localId === localId);
      if (exists) return prev;
      return [...prev, botMessage];
    });

    if (socket && activeRoom) {
      botMessage.room = activeRoom;
      socket.emit("message", botMessage);
      emittedToSocketRef.current.add(localId);
      emittedToSocketRef.current.add(messageText);
    }
  };

  const sendUserMessage = (messageText) => {
    const activeRoom = getActiveRoomId();
    const roomIdToUse = activeRoom || tempRoomIdRef.current;
    const customerDetails =
      JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details")) ||
      {};
    const localId = genLocalId();

    const userMessage = {
      localId,
      room: roomIdToUse,
      sender: "Customer",
      senderId: customerDetails?._id || "",
      message: messageText,
      attachment: null,
      attachmentType: null,
      uniquePartnerId: widgetConfigs?.uniquePartnerId,
      timestamp: new Date().toISOString(),
    };

    console.log("👤 Sending user message:", userMessage);

    // Mark processed so server echo won't duplicate (localId + content signature)
    markProcessed(localId);
    const contentSignature = `${userMessage.sender}_${userMessage.senderId}_${userMessage.timestamp}_${userMessage.message}`;
    markProcessed(contentSignature);
    const contentSignatureNoTs = buildSignatureNoTs(
      userMessage.sender,
      userMessage.senderId,
      userMessage.message
    );
    markProcessed(contentSignatureNoTs);

    // If bot is active, also record user answer into automated history
    if (!botCompleted && !botConversationCompleted) {
      setAutomatedHistory((prev) => {
        const next = [...prev, userMessage];
        saveAutomatedHistory(widgetConfigs?.uniquePartnerId, next);
        return next;
      });
    }

    // Add to local messages for immediate display
    setLocalMessages((prev) => {
      const exists = prev.some((m) => m.localId === localId);
      if (exists) return prev;
      return [...prev, userMessage];
    });

    if (socket && activeRoom) {
      userMessage.room = activeRoom;
      socket.emit("message", userMessage);
      emittedToSocketRef.current.add(localId);
      emittedToSocketRef.current.add(messageText);
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const uploadFileToServer = async (file) => {
    const formData = new FormData();
    formData.append("attachment", file);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/attachment`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) throw new Error("Upload failed");
      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Upload error:", error);
      return null;
    }
  };

  const uploadAndSendAttachment = async (file) => {
    if (!file) return;
    try {
      setUploadingAttachment(true);
      const result = await uploadFileToServer(file);
      const fileUrl = result?.data?.url || result?.url;
      const fileName = result?.data?.filename || file.name || "Attachment";
      const fileType = result?.data?.type || file.type;

      if (fileUrl) {
        let room = convo?.roomId;
        if (!room) {
          const activeSession = getValidChatSession(widgetConfigs?.uniquePartnerId);
          if (activeSession && activeSession.conversation?.roomId) {
            room = activeSession.conversation.roomId;
            dispatch(setConvo(activeSession.conversation));
          }
        }

        const customerDetails =
          JSON.parse(
            localStorage.getItem("dexkor-chat-widget-customer-details")
          ) || {};
        const localId = genLocalId();

        const msg = {
          localId,
          room: room,
          sender: "Customer",
          senderId: customerDetails?._id || "",
          message: "",
          attachment: fileUrl,
          attachmentType: fileType,
          attachments: [
            {
              url: fileUrl,
              filename: fileName,
              type: fileType,
              size: file.size,
            },
          ],
          timestamp: new Date().toISOString(),
        };

        markProcessed(localId);
        markProcessed(buildSignatureNoTs(msg.sender, msg.senderId, fileUrl));

        if (socket && room) {
          socket.emit("message", msg);
        }

        setLocalMessages((prev) => [...prev, msg]);
      }
    } catch (err) {
      console.error("Error uploading attachment:", err);
    } finally {
      setUploadingAttachment(false);
    }
  };

  const handleFileAttachment = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploadingAttachment(true);
      const result = await uploadFileToServer(file);
      const fileUrl = result?.data?.url || result?.url;
      if (fileUrl) {
        setAttachment(fileUrl);
        setAttachmentType(file.type || "application/octet-stream");
      }
    } catch (err) {
      console.error("Error uploading attachment:", err);
    } finally {
      setUploadingAttachment(false);
      if (e.target) e.target.value = "";
    }
  };

  const captureScreenshot = async () => {
    const host = document.getElementById("chat-widget-container");
    const shadowRoot = host?.shadowRoot;
    const chatPanel = shadowRoot?.querySelector(".dexkor-chat-widget-panel");
    const draggableTrigger = shadowRoot?.querySelector(".dexkor-draggable-trigger");

    try {
      if (chatPanel) chatPanel.style.display = "none";
      if (draggableTrigger) draggableTrigger.style.display = "none";

      await new Promise((resolve) => requestAnimationFrame(resolve));

      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      const scrollX = window.pageXOffset || document.documentElement.scrollLeft;

      const canvas = await html2canvas(document.body, {
        useCORS: true,
        scale: window.devicePixelRatio || 2,
        logging: false,
        x: scrollX,
        y: scrollY,
        width: window.innerWidth,
        height: window.innerHeight,
        scrollX: 0,
        scrollY: 0,
        windowWidth: document.documentElement.clientWidth,
        windowHeight: document.documentElement.clientHeight,
      });

      canvas.toBlob(async (blob) => {
        if (chatPanel) chatPanel.style.display = "block";
        if (draggableTrigger) draggableTrigger.style.display = "block";

        if (blob) {
          const file = new File([blob], `screenshot-${Date.now()}.png`, {
            type: "image/png",
          });
          await uploadAndSendAttachment(file);
        }
      }, "image/png", 1.0);
    } catch (error) {
      if (chatPanel) chatPanel.style.display = "block";
      if (draggableTrigger) draggableTrigger.style.display = "block";
      console.error("Screenshot failed:", error);
    }
  };

  const startScreenRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
      });

      mediaRecorderRef.current = new MediaRecorder(stream, {
        mimeType: "video/webm; codecs=vp9",
      });

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.onstop = async () => {
        const blob = new Blob(audioChunksRef.current, { type: "video/webm" });
        const file = new File([blob], `screen-record-${Date.now()}.webm`, {
          type: "video/webm",
        });

        await uploadAndSendAttachment(file);

        audioChunksRef.current = [];
        setIsScreenRecording(false);
        clearInterval(timerIntervalRef.current);
        setRecordingTime(0);
        stream.getTracks().forEach((track) => track.stop());
      };

      mediaRecorderRef.current.start();
      setIsScreenRecording(true);
      setRecordingTime(0);
      timerIntervalRef.current = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);

      setTimeout(() => {
        if (
          mediaRecorderRef.current &&
          mediaRecorderRef.current.state !== "inactive"
        ) {
          mediaRecorderRef.current.stop();
        }
      }, 8000);
    } catch (error) {
      console.error("Error starting screen recording:", error);
      setIsScreenRecording(false);
    }
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) audioChunksRef.current.push(event.data);
      };

      mediaRecorderRef.current.onstop = async () => {
        const blob = new Blob(audioChunksRef.current, { type: "audio/webm" });
        const file = new File([blob], "voicemail.webm", { type: "audio/webm" });
        await uploadAndSendAttachment(file);
        audioChunksRef.current = [];
        setRecording(false);
        clearInterval(timerIntervalRef.current);
        setRecordingTime(0);
      };

      mediaRecorderRef.current.start();
      setRecording(true);
      setRecordingTime(0);
      timerIntervalRef.current = setInterval(() => {
        setRecordingTime((prev) => prev + 1);
      }, 1000);
    } catch (error) {
      console.error("Error starting audio recording:", error);
    }
  };

  const stopRecording = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== "inactive"
    ) {
      mediaRecorderRef.current.stop();
      clearInterval(timerIntervalRef.current);
    }
  };

  let touchTimer;
  const startTranscription = () => {
    if (!("webkitSpeechRecognition" in window)) {
      console.error("Speech recognition is not supported in this browser.");
      return;
    }

    recognitionRef.current = new window.webkitSpeechRecognition();
    recognitionRef.current.continuous = true;
    recognitionRef.current.interimResults = true;
    recognitionRef.current.lang = "en-US";

    let finalTranscript = "";

    recognitionRef.current.onresult = (event) => {
      let interimTranscript = "";
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        } else {
          interimTranscript += event.results[i][0].transcript;
        }
      }
      setUserInput(finalTranscript + interimTranscript);
    };

    recognitionRef.current.start();
    setTranscribing(true);
  };

  const stopTranscription = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
      setTranscribing(false);
    }
  };

  const handleTouchStart = () => {
    clearTimeout(touchTimer);
    touchTimer = setTimeout(() => {
      startTranscription();
    }, 100);
  };

  const handleTouchEnd = () => {
    clearTimeout(touchTimer);
    stopTranscription();
  };

  const sendNormalMessage = (choice = null) => {
    const selectedChoice = typeof choice?.text === 'string' ? choice : null;
    let room = convo?.roomId;
    if (!room) {
      const activeSession = getValidChatSession(widgetConfigs?.uniquePartnerId, setupDetails?.widgetWorkflow?.workflowId);
      if (activeSession && activeSession.conversation?.roomId) {
        room = activeSession.conversation.roomId;
        dispatch(setConvo(activeSession.conversation));
      }
    }

    if (!room) {
      console.error("Can not send message, convo missing!");
      return;
    }

    const inputMessage = selectedChoice ? selectedChoice.text : userInput.trim();
    if (inputMessage || attachment) {
      if (dexyActive || builderWorkflowActive) setBotTyping(true);
      const customerDetails =
        JSON.parse(
          localStorage.getItem("dexkor-chat-widget-customer-details")
        ) || {};
      const localId = genLocalId();

      const finalAttachments = attachment && !selectedChoice
        ? [
          {
            url: attachment,
            type: attachmentType,
            filename: attachment.split("/").pop() || "Attachment",
          },
        ]
        : null;

      const msg = {
        localId,
        room: room,
        sender: "Customer",
        type: "External",
        uniquePartnerId: widgetConfigs?.uniquePartnerId,
        senderId: customerDetails?._id || "",
        message: inputMessage || "",
        interactiveReplyId: selectedChoice?.id || null,
        metadata: { supportsButtons: true, ...(selectedChoice?.workflowNodeId ? { workflowNodeId: selectedChoice.workflowNodeId } : {}) },
        attachment: selectedChoice ? null : attachment || null,
        attachmentType: selectedChoice ? null : attachmentType || null,
        attachments: finalAttachments,
        timestamp: new Date().toISOString(),
      };

      // Mark processed (localId + content signature)
      markProcessed(localId);
      const contentSignature = `${msg.sender}_${msg.senderId}_${msg.timestamp}_${msg.message || msg.attachment || ""}`;
      markProcessed(contentSignature);
      const contentSignatureNoTs = buildSignatureNoTs(
        msg.sender,
        msg.senderId,
        msg.message || msg.attachment || localId
      );
      markProcessed(contentSignatureNoTs);

      if (socket && room) {
        socket.emit("message", msg);
      }
      if (!selectedChoice) {
        setUserInput("");
        setAttachment(null);
        setAttachmentType(null);
      }

      // Add to local messages for immediate display
      setLocalMessages((prev) => {
        const exists = prev.some((m) => m.localId === localId);
        if (exists) return prev;
        return [...prev, msg];
      });
    }
  };

  const handleAutoAdvance = async (currentQ) => {
    if (!legacyWorkflow) return;
    if (processingRef.current) return;
    processingRef.current = true;

    try {
      if (!currentQ.nextQuestionId) {
        console.log("🔚 No next question, ending bot conversation");
        setTimeout(() => {
          sendBotMessage(
            "Thank you for your time! I'm now connecting you with a live agent who can help you further."
          );
          // Mark bot conversation as completed
          completeBotConversation();
        }, 800);
        setCurrentQuestion(null);
        return;
      }

      setLoading(true);
      console.log("➡️ Auto-advancing to:", currentQ.nextQuestionId);

      const response = await fetch(
        `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/${currentQ.nextQuestionId}?uniquePartnerId=${widgetConfigs.uniquePartnerId}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const nextQuestion = await response.json();
      console.log("📝 Next question loaded:", nextQuestion.text);

      if (!nextQuestion || nextQuestion.type === "end") {
        setTimeout(() => {
          sendBotMessage(
            (nextQuestion && nextQuestion.text) ||
            "Thank you for your time! I'm now connecting you with a live agent who can help you further."
          );
          completeBotConversation();
        }, 800);
        setCurrentQuestion(null);
        return;
      }

      setCurrentQuestion(nextQuestion);
      saveBotProgress(nextQuestion, localMessages, automatedHistory);

      setTimeout(() => {
        sendBotMessage(nextQuestion.text);

        // Continue auto-advance if needed
        if (
          nextQuestion.type === "message" &&
          nextQuestion.messageSettings?.autoAdvance
        ) {
          setTimeout(() => {
            handleAutoAdvance(nextQuestion);
          }, nextQuestion.messageSettings.delay || 1500);
        }
      }, 800);
    } catch (error) {
      console.error("❌ Error in auto-advance:", error);
      sendBotMessage("Sorry, something went wrong. Please try again.");
    } finally {
      setLoading(false);
      processingRef.current = false;
    }
  };

  const completeBotConversation = () => {
    setBotCompleted(true);
    setConversationEnded(false); // Don't end conversation, just transition to live chat
    setCurrentQuestion(null);
    setBotConversationCompleted(true);

    // Clear in-progress state since bot is now fully finished
    clearBotProgress();

    // Mark bot conversation as completed in localStorage
    if (convo?.roomId) {
      localStorage.setItem(`bot_completed_${convo.roomId}`, "true");
    }

    // Save automated history so returning to this tab displays it
    if (automatedHistory.length > 0) {
      saveAutomatedHistory(widgetConfigs?.uniquePartnerId, automatedHistory, true);
    } else if (localMessages.length > 0) {
      const autoMsgs = localMessages.map((m) => ({ ...m, isAutomated: true }));
      setAutomatedHistory(autoMsgs);
      saveAutomatedHistory(widgetConfigs?.uniquePartnerId, autoMsgs, true);
    }

    // Flush all bot questions and user answers to the ticket room via socket
    const activeRoom = convo?.roomId || getActiveRoomId();
    if (activeRoom) {
      flushAutomatedHistoryToSocket(activeRoom);
    }

    // Update 24-hour session so it persists that bot is completed
    saveChatSession(widgetConfigs?.uniquePartnerId, {
      botCompleted: true,
      roomId: activeRoom,
      ticketId: convo?.ticketId,
      conversation: convo,
    });
    if (activeRoom) socket.emit('widget:handoff', { roomId: activeRoom, uniquePartnerId: widgetConfigs?.uniquePartnerId });
  };

  const handleSendMessage = async (userAnswer) => {
    if (!legacyWorkflow) {
      sendNormalMessage(typeof userAnswer === 'string' ? { text: userAnswer } : null);
      return;
    }
    if (processingRef.current) return;

    // If bot is active, validate and process bot flow
    if (!botCompleted && currentQuestion) {
      // ✅ Add client-side validation before sending
      if (currentQuestion && currentQuestion.type === "data_collection") {
        const validation = validateInput(userAnswer, currentQuestion);
        if (!validation.isValid) {
          setValidationError(validation.error);
          setIsValid(false);
          return;
        }
      }

      processingRef.current = true;

      try {
        setLoading(true);
        setValidationError("");

        // Send user message via socket
        if (userAnswer && userAnswer.trim()) {
          sendUserMessage(userAnswer);
          setUserInput("");
        }

        console.log("💬 Processing user response:", userAnswer);

        const response = await fetch(
          `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/answer`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              userId: generateUserId(),
              questionId: currentQuestion._id,
              answer: userAnswer || "",
              uniquePartnerId: widgetConfigs.uniquePartnerId,
            }),
          }
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          if (response.status === 400 && errorData.validationError) {
            setValidationError(errorData.validationError);
            setIsValid(false);
            return;
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log("📨 API Response:", result);

        // Handle response based on action
        switch (result.action) {
          case "external_link":
            console.log("🔗 Opening external link:", result.externalLink);
            if (result.externalLink) {
              window.open(result.externalLink, "_blank", "noopener,noreferrer");
            }

            setTimeout(() => {
              if (result.nextQuestion) {
                sendBotMessage("Link opened! Meanwhile...");
                setTimeout(() => {
                  setCurrentQuestion(result.nextQuestion);
                  sendBotMessage(result.nextQuestion.text);
                }, 1000);
              } else {
                sendBotMessage("Link opened in new tab. Thank you!");
                completeBotConversation();
              }
            }, 800);
            break;

          case "external_link_with_followup":
            console.log(
              "🔗 Opening external link with followup:",
              result.externalLink
            );
            if (result.externalLink) {
              window.open(result.externalLink, "_blank", "noopener,noreferrer");
            }

            if (result.nextQuestion) {
              setTimeout(() => {
                setCurrentQuestion(result.nextQuestion);
                sendBotMessage("Great! I've opened the link in a new tab.");
                setTimeout(() => {
                  sendBotMessage(result.nextQuestion.text);
                }, 1000);
              }, 800);
            }
            break;

          case "end_conversation":
            setTimeout(() => {
              sendBotMessage(
                result.message ||
                "Thank you for your time! I'm now connecting you with a live agent."
              );
              completeBotConversation();
            }, 800);
            setCurrentQuestion(null);
            break;

          case "next_question":
          default:
            if (result.externalLink) {
              console.log(
                "🔗 Opening external link from next_question:",
                result.externalLink
              );
              window.open(result.externalLink, "_blank", "noopener,noreferrer");
            }

            const isEnd =
              !result.nextQuestion ||
              result.nextQuestion.type === "end";

            if (!isEnd && result.nextQuestion) {
              console.log(
                "➡️ Moving to next question:",
                result.nextQuestion.text
              );
              setCurrentQuestion(result.nextQuestion);
              saveBotProgress(result.nextQuestion, localMessages, automatedHistory);

              setTimeout(() => {
                if (result.externalLink) {
                  sendBotMessage(
                    "I've opened the link in a new tab. Meanwhile..."
                  );
                  setTimeout(() => {
                    sendBotMessage(result.nextQuestion.text);
                  }, 1000);
                } else {
                  sendBotMessage(result.nextQuestion.text);
                }

                if (
                  result.nextQuestion.type === "message" &&
                  result.nextQuestion.messageSettings?.autoAdvance
                ) {
                  setTimeout(() => {
                    handleAutoAdvance(result.nextQuestion);
                  }, result.nextQuestion.messageSettings.delay || 1500);
                }
              }, 800);
            } else {
              setTimeout(() => {
                sendBotMessage(
                  (result.nextQuestion && result.nextQuestion.text) ||
                  result.message ||
                  "Thank you for your time! I'm now connecting you with a live agent."
                );
                completeBotConversation();
              }, 800);
              setCurrentQuestion(null);
            }
            break;
        }
      } catch (error) {
        console.error("❌ Error processing message:", error);
        sendBotMessage("Sorry, something went wrong. Please try again.");
      } finally {
        setLoading(false);
        processingRef.current = false;
      }
    } else {
      // Bot conversation ended or already completed - send normal message to live agent
      if (userAnswer && userAnswer.trim()) {
        sendUserMessage(userAnswer);
        setUserInput("");
      }
    }
  };

  const handleInputKeyPress = (e) => {
    if (e.key === "Enter" && !loading && userInput.trim() && isValid) {
      if (!legacyWorkflow || botCompleted) {
        sendNormalMessage();
      } else {
        handleSendMessage(userInput.trim());
      }
    }
  };

  useEffect(() => {
    if (!initialMessage) {
      initialMessageSentRef.current = false;
      return;
    }
    if (initialMessageSentRef.current || !convo?.roomId || !initialized || loading) return;
    if (legacyWorkflow && !botCompleted && !botConversationCompleted
      && (!currentQuestion || currentQuestion.type === 'message' || processingRef.current)) return;
    initialMessageSentRef.current = true;
    handleSendMessage(initialMessage);
    onMessageConsumed?.();
  }, [initialMessage, convo?.roomId, initialized, loading, legacyWorkflow, currentQuestion, botCompleted, botConversationCompleted]);

  const handleChoiceClick = (choice) => {
    if (loading) return;

    console.log("🎯 Choice clicked:", choice);

    if (choice.actionType === "external_link" && choice.actionValue) {
      console.log("🔗 Opening external link from choice:", choice.actionValue);
      window.open(choice.actionValue, "_blank", "noopener,noreferrer");
    }

    handleSendMessage(choice.label);
  };

  // Socket message handling with proper deduplication
  useEffect(() => {
    const activeRoom = convo?.roomId || getActiveRoomId();
    if (!activeRoom) return;

    const handleIncomingMessage = (rawMessage) => {
      try {
        if (!rawMessage) return;
        // Clone message so we do not mutate incoming socket payload or Redux state
        const message = {
          ...rawMessage,
          timestamp:
            rawMessage.timestamp && typeof rawMessage.timestamp !== "string"
              ? new Date(rawMessage.timestamp).toISOString()
              : rawMessage.timestamp,
        };

        // Create a unique identifier for the message
        const messageId =
          message.localId ||
          message._id ||
          `${message.sender}_${message.senderId}_${message.timestamp}_${message.message || message.attachment || ""}`;
        const signatureNoTs = buildSignatureNoTs(
          message.sender,
          message.senderId,
          message.message || message.attachment || message._id || ""
        );

        // Skip if already processed
        if (isProcessed(messageId) || isProcessed(signatureNoTs)) {
          console.log("🔄 Skipping already processed message:", messageId);
          return;
        }

        // Mark as processed
        markProcessed(messageId);
        markProcessed(signatureNoTs);
        if (message._id) markProcessed(message._id);
        if (message.requestId) markProcessed(message.requestId);

        // Only add if it belongs to this chat room
        const currentActiveRoom = convo?.roomId || getActiveRoomId();
        if (message.room === currentActiveRoom || message.room === convo?.roomId) {
          if (message.sender === 'Chatbot' || message.sender === 'Agent' || message.isBot) setBotTyping(false);
          if (message.sender === "Agent" && !message.isBot && message.metadata?.source !== "workflow") {
            dispatch(setConvo({ ...convo, botHandled: "handed_off" }));
          }

          // Trigger word-by-word streaming effect if bot answer
          const isBotMsg = message.isBot || message.sender === "Chatbot" || message.sender === "Bot" || message.fromAddress === "Dexy AI" || message.metadata?.source === "dexy_ai" || message.metadata?.source === "workflow";
          if (isBotMsg && message.message && typeof message.message === "string") {
            const stableMsgId = message._id || message.clientMessageId || message.localId || `bot_msg_${Date.now()}`;
            const rawContent = message.message;
            const words = rawContent.split(" ");

            if (words.length > 3) {
              if (activeIntervalRef.current) {
                clearInterval(activeIntervalRef.current);
                activeIntervalRef.current = null;
              }

              setStreamingMessageId(stableMsgId);
              let currentWordIndex = 0;
              setStreamedTextMap((prev) => ({ ...prev, [stableMsgId]: words[0] }));

              activeIntervalRef.current = setInterval(() => {
                currentWordIndex += 1;
                if (currentWordIndex < words.length) {
                  setStreamedTextMap((prev) => ({
                    ...prev,
                    [stableMsgId]: words.slice(0, currentWordIndex + 1).join(" "),
                  }));
                  if (chatContainerRef.current) {
                    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
                  }
                } else {
                  clearInterval(activeIntervalRef.current);
                  activeIntervalRef.current = null;
                  setStreamingMessageId(null);
                  setStreamedTextMap((prev) => ({ ...prev, [stableMsgId]: rawContent }));
                }
              }, 30);
            } else {
              setStreamedTextMap((prev) => ({ ...prev, [stableMsgId]: rawContent }));
            }
          }

          setLocalMessages((prev) => {
            const existsIndex = prev.findIndex((m) => areMessagesEquivalent(m, message));
            if (existsIndex !== -1) {
              if (message._id && !prev[existsIndex]._id) {
                const updated = [...prev];
                updated[existsIndex] = { ...updated[existsIndex], ...message };
                return updated;
              }
              return prev;
            }
            return [...prev, message];
          });
        }
      } catch (err) {
        console.error("Error handling incoming message:", err);
      }
    };

    const onConnect = () => {
      const roomToJoin = convo?.roomId || getActiveRoomId();
      if (roomToJoin) {
        console.log("🟢 Connected to socket, joining room:", roomToJoin);
        socket.emit("join", [roomToJoin]);
      }
    };

    const onBotStatus = payload => {
      if (payload.roomId === activeRoom && payload.botHandled === 'handed_off') setBotTyping(false);
      if (payload.roomId === activeRoom) dispatch(setConvo({ ...convo, botHandled: payload.botHandled }));
    };
    const onTyping = payload => {
      if (payload.roomId === activeRoom) setBotTyping(payload.typing === true);
    };
    const onDisconnect = () => setBotTyping(false);

    // Clean up previous listeners
    socket.off("message", handleIncomingMessage);
    socket.off("receiveMessage", handleIncomingMessage);
    socket.off("connect", onConnect);

    // Add new listeners
    socket.on("message", handleIncomingMessage);
    socket.on("receiveMessage", handleIncomingMessage);
    socket.on("connect", onConnect);
    socket.on('conversation:botStatus', onBotStatus);
    socket.on('conversation:typing', onTyping);
    socket.on('disconnect', onDisconnect);

    if (activeRoom) {
      socket.emit("join", [activeRoom]);
    }

    return () => {
      socket.off("message", handleIncomingMessage);
      socket.off("receiveMessage", handleIncomingMessage);
      socket.off("connect", onConnect);
      socket.off('conversation:botStatus', onBotStatus);
      socket.off('conversation:typing', onTyping);
      socket.off('disconnect', onDisconnect);
    };
  }, [convo?.roomId]);

  const goBack = () => {
    const fallback = getFallbackBackView(setupDetails);
    setView(fallback.view);
    if (setActiveIcon) setActiveIcon(fallback.icon);
  };

  // If bot conversation was already completed, show normal chat interface
  if (!legacyWorkflow || botCompleted || botConversationCompleted) {
    return (
      <div className="flex flex-col h-full w-full flex-1 min-h-0 overflow-hidden bg-white relative">
        {/* Gleap Enterprise White Header (DexyAi layout matching) */}
        <div className="flex items-center justify-between px-4 h-14 border-b border-slate-100 shrink-0 bg-white sticky top-0 z-10">
          <div className="flex items-center justify-start gap-2">

          <button
            onClick={goBack}
            className="w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all border-none outline-none cursor-pointer"
            title="Back"
          >
            <ChevronLeft className="w-5 h-5 stroke-[2.2]" />
          </button>

          {!convo?.roomId ? (
            /* While Session is connecting / initializing: Show 3 overlapping active agents from auth microservice + Brand Name (DexyAi style) */
            <div className="flex items-center gap-2.5">
              <div className="flex items-center -space-x-2">
                {availableAgents && availableAgents.length > 0 ? (
                  availableAgents.slice(0, 3).map((ag, idx) =>
                    ag.avatar ? (
                      <img
                        key={ag.id || idx}
                        src={ag.avatar}
                        alt={ag.name}
                        title={`${ag.name} (Active)`}
                        className="w-8 h-8 rounded-full object-cover ring-2 ring-white shadow-sm"
                      />
                    ) : (
                      <div
                        key={ag.id || idx}
                        title={`${ag.name} (Active)`}
                        className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white ring-2 ring-white shadow-sm"
                        style={{
                          backgroundColor: idx === 0 ? "#2563eb" : idx === 1 ? "#7c3aed" : "#059669",
                        }}
                      >
                        {ag.initials}
                      </div>
                    )
                  )
                ) : (
                  <div className="flex items-center -space-x-2">
                    <div className="w-8 h-8 rounded-full bg-slate-200 animate-pulse ring-2 ring-white" />
                    <div className="w-8 h-8 rounded-full bg-slate-200 animate-pulse ring-2 ring-white" />
                    <div className="w-8 h-8 rounded-full bg-slate-200 animate-pulse ring-2 ring-white" />
                  </div>
                )}
              </div>
              <span className="font-bold text-slate-900 text-sm ml-1">{brandName}</span>
            </div>
          ) : convo?.botHandled === "handed_off" ? (
            /* Live Agent Header — show agent details if they replied, else show waiting state */
            activeAgent ? (
              <div className="flex items-center gap-2.5 text-left">
                <div className="relative">
                  {activeAgent.avatar ? (
                    <img
                      src={activeAgent.avatar}
                      alt={activeAgent.name || "Agent"}
                      className="w-8 h-8 rounded-full object-cover ring-2 ring-slate-100 shadow-sm"
                    />
                  ) : (
                    <div
                      className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold shadow-sm"
                      style={{ backgroundColor: uiColor }}
                    >
                      {activeAgent.initials || "A"}
                    </div>
                  )}
                  <span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-emerald-500 ring-2 ring-white" />
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-slate-900 text-sm leading-tight">
                    {activeAgent.name || "Support Agent"}
                  </span>
                  <span className="text-[11px] text-emerald-600 font-medium leading-tight mt-0.5">
                    Active now
                  </span>
                </div>
              </div>
            ) : (
              /* No agent has replied yet — show waiting state */
              <div className="flex items-center gap-2.5 text-left">
                <div className="relative">
                  <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center shadow-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-amber-400 ring-2 ring-white animate-pulse" />
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-slate-900 text-sm leading-tight">
                    Live Support
                  </span>
                  <span className="text-[11px] text-amber-600 font-medium leading-tight mt-0.5">
                    Waiting for agent to connect...
                  </span>
                </div>
              </div>
            )
          ) : (
            /* Active Bot / Builder Assistant Header */
            <div className="flex items-center gap-2.5 text-left">
              {dexyActive || isBuilderMode || setupDetails?.widgetWorkflow?.workflowId === 'dexy_ai' ? (
                <DexyBotIcon className="w-8 h-8" dotClass="w-1.5 h-1.5" gap="gap-[3px]" />
              ) : (
                <div className="w-8 h-8 rounded-full bg-slate-800 text-white flex items-center justify-center shadow-sm">
                  <Bot className="w-4.5 h-4.5 text-white" />
                </div>
              )}
              <div className="flex flex-col">
                <span className="font-bold text-slate-900 text-sm leading-tight">
                  {dexyActive
                    ? (setupDetails?.widgetCustomizations?.aiBotName || "Dexy AI")
                    : isBuilderMode
                    ? "Dexy Bot"
                    : (setupDetails?.widgetCustomizations?.botName || "Support Bot")}
                </span>
                <span className="text-[11px] text-slate-400 font-normal leading-tight mt-0.5">
                  Our bot will reply instantly
                </span>
              </div>
            </div>
          )}
          </div>

          <button
            onClick={() => {
              if (setIsOpen) setIsOpen(false);
            }}
            className="w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all border-none outline-none cursor-pointer"
            title="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Scrollable Messages Area */}
        <div
          ref={chatContainerRef}
          className="flex-1 overflow-y-auto p-4 space-y-3 dexkor-scrollbar bg-slate-50/50 min-h-0"
        >
          {/* 1. Automated Chat History Section (shown first!) */}
          {legacyWorkflow && automatedHistory && automatedHistory.length > 0 && (
            <div className="mb-4">
              <div className="flex items-center justify-center mb-3">
                <div className="flex items-center gap-1.5 px-3 py-1 bg-white/90 rounded-full border border-slate-200/90 shadow-2xs">
                  <Bot className="w-3.5 h-3.5 text-slate-700" />
                  <span className="text-[11px] font-semibold text-slate-700 tracking-wide uppercase">
                    Automated Assistant
                  </span>
                </div>
              </div>

              <div className="space-y-2.5">
                {automatedHistory.map((msg, index) => (
                  <div
                    key={msg.localId || `auto-${index}`}
                    className={`flex ${msg.sender === "Customer" ? "justify-end" : "justify-start"
                      } mb-2`}
                  >
                    {msg.sender !== "Customer" && (
                      <div className="w-7 h-7 mr-2 shrink-0 flex items-center justify-center rounded-full bg-slate-800 text-white shadow-xs">
                        <Bot className="w-3.5 h-3.5 text-white" />
                      </div>
                    )}
                    <div
                      className={`max-w-[80%] rounded-2xl p-3 shadow-xs ${msg.sender === "Customer"
                          ? "bg-slate-900 text-white rounded-br-xs"
                          : "bg-white text-slate-800 border border-slate-200/90 rounded-bl-xs"
                        }`}
                    >
                      <p className="text-xs sm:text-sm leading-relaxed whitespace-pre-wrap break-words">
                        {msg.message}
                      </p>
                      <p
                        className={`text-[10px] mt-1 ${msg.sender === "Customer"
                            ? "text-slate-400 text-right"
                            : "text-slate-400"
                          }`}
                      >
                        {msg.timestamp
                          ? new Date(msg.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                          : ""}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Divider separating Automated Chat and Live Agent */}
              <div className="relative flex items-center justify-center my-4">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-slate-200" />
                </div>
                <div className="relative flex items-center gap-1.5 bg-white px-3 py-1 rounded-full border border-emerald-200 shadow-2xs">
                  <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                  <span className="text-[11px] font-semibold text-emerald-800">
                    Live Chat
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* If no automated history, still show the Live Agent Connected badge */}
          {(!legacyWorkflow || !automatedHistory || automatedHistory.length === 0) && (
            <div className="flex flex-col items-center my-2">
              <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-100 px-3 py-1.5 rounded-full shadow-xs">
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                <span className="text-xs font-semibold text-emerald-800">
                  {convo?.botHandled === 'handed_off'
                    ? 'Live Agent Connected'
                    : isBuilderMode
                    ? 'Dexy Bot Active'
                    : dexyActive
                    ? 'AI Assistant'
                    : 'Live Chat'}
                </span>
              </div>
            </div>
          )}

          {/* 2. Live Conversation Messages (below the automated chat history) */}
          {liveMessages.map((msg, index) => {
            const isCustomer = msg.sender === "Customer";
            const msgId = msg.localId || msg._id || msg.clientMessageId || `msg_${index}`;
            const isCurrentlyStreaming = streamingMessageId === msgId;
            const rawMsgText = isCurrentlyStreaming ? (streamedTextMap[msgId] || msg.message) : msg.message;
            const cleanedMessage = cleanAndSanitizeMessage(rawMsgText);
            const hasAttachments = Boolean(
              msg.attachment ||
              (Array.isArray(msg.attachments) && msg.attachments.length > 0)
            );
            const agentDetails = !isCustomer
              ? resolveAgentDetails(msg, setupDetails, convo)
              : null;

            return (
              <div
                key={msg.localId || msg._id || index}
                className={`flex flex-col ${isCustomer ? "items-end" : "items-start"
                  } mb-3`}
              >
                {/* Agent Avatar & Name Header above agent bubble */}
                {!isCustomer && (
                  <div className="flex items-center gap-2 mb-1.5">
                    {/* Agent Avatar: Profile photo if available, or Bot icon if bot, or initials gradient circle */}
                    <div className="w-6 h-6 shrink-0 relative flex items-center justify-center">
                      {agentDetails.avatar ? (
                        <img
                          src={agentDetails.avatar}
                          alt={agentDetails.name}
                          className="w-6 h-6 rounded-full object-cover border border-slate-200 shadow-2xs"
                          onError={(e) => {
                            e.target.style.display = "none";
                            if (e.target.nextSibling) {
                              e.target.nextSibling.style.display = "flex";
                            }
                          }}
                        />
                      ) : null}
                      {agentDetails.isDexy || agentDetails.name === "Dexy Bot" || agentDetails.name === "Dexy" ? (
                        <div style={{ display: agentDetails.avatar ? "none" : "flex" }}>
                          <DexyBotIcon className="w-6 h-6" dotClass="w-1 h-1" gap="gap-[2px]" />
                        </div>
                      ) : agentDetails.isBot ? (
                        <div
                          style={{ display: agentDetails.avatar ? "none" : "flex" }}
                          className="w-6 h-6 rounded-full bg-slate-800 text-white items-center justify-center shadow-xs"
                        >
                          <Bot className="w-3.5 h-3.5 text-white" />
                        </div>
                      ) : (
                        <div
                          style={{ display: agentDetails.avatar ? "none" : "flex" }}
                          className="w-6 h-6 rounded-full bg-gradient-to-tr from-blue-600 to-indigo-600 text-white items-center justify-center text-[10px] font-bold shadow-xs tracking-tight select-none"
                        >
                          {agentDetails.initials}
                        </div>
                      )}
                    </div>
                    <span className="text-xs font-semibold text-slate-800">
                      {agentDetails.name}
                    </span>
                  </div>
                )}

                <div
                  className={`flex ${isCustomer ? "justify-end" : "justify-start"
                    } w-full`}
                >

                  <div
                    className={`max-w-[80%] rounded-2xl p-3 shadow-xs ${isCustomer
                        ? "bg-slate-900 text-white rounded-br-xs"
                        : "bg-white text-slate-800 border border-slate-200/80 rounded-bl-xs"
                      }`}
                  >
                    {/* Attachments - rendered like Ticket */}
                    {hasAttachments && (
                      <div className="mb-1.5">
                        <RenderAttachment
                          attachment={msg.attachment}
                          attachmentType={msg.attachmentType}
                          attachments={msg.attachments}
                        />
                      </div>
                    )}
                    {cleanedMessage && (
                      <div
                        className="text-xs sm:text-sm leading-relaxed break-words [&>p]:mb-1 [&>p:last-child]:mb-0 [&>div]:mb-1 [&>div:last-child]:mb-0"
                        dangerouslySetInnerHTML={{
                          __html: cleanedMessage,
                        }}
                      />
                    )}
                    {isCurrentlyStreaming && (
                      <span className="inline-block w-1.5 h-3.5 bg-slate-400 ml-1 animate-pulse align-middle" />
                    )}
                    {!isCustomer && Array.isArray(msg.metadata?.options) && (
                      <div className="flex flex-wrap gap-2 mt-3">
                        {msg.metadata.options.filter(option => option.action !== 'handoff' || msg.metadata.workflowNodeId).map(option => (
                          <button type="button" key={option.id}
                            disabled={convo?.botHandled === 'handed_off' || (option.action !== 'handoff' && msg !== [...liveMessages].reverse().find(m => m.metadata?.options?.some(o => o.action !== 'handoff')))}
                            onClick={() => sendNormalMessage({ text: option.label, id: option.id, workflowNodeId: option.action === 'handoff' ? null : msg.metadata.workflowNodeId })}
                            className="px-3 py-2 rounded-xl border border-blue-200 bg-blue-50 text-blue-700 text-xs font-semibold hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed">
                            {option.label}
                          </button>
                        ))}
                      </div>
                    )}
                    <p
                      className={`text-[10px] mt-1 ${isCustomer
                          ? "text-slate-300 text-right"
                          : "text-slate-400"
                        }`}
                    >
                      {msg.timestamp
                        ? new Date(msg.timestamp).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                        : "Just now"}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}

          {/* CSAT Prompt: Only below the last Dexy AI / Builder bot message, and only while no agent is handling */}
          {(() => {
            // Only show when bot (Dexy / Builder) is the active responder — not during/after agent handoff
            const isBotResponder = dexyActive || isBuilderMode;
            if (!isBotResponder) return null;
            if (convo?.botHandled === "handed_off") return null;

            const lastBotMsg = [...liveMessages].reverse().find(
              (m) =>
                m.type !== "Internal" &&
                (m.sender === "Chatbot" ||
                  m.sender === "Bot" ||
                  m.fromAddress === "Dexy AI" ||
                  m.fromAddress === "Dexy Bot" ||
                  m.fromAddress === "Dexy" ||
                  m.metadata?.source === "dexy_ai" ||
                  m.metadata?.source === "workflow" ||
                  m.isBot === true)
            );

            if (!lastBotMsg || botTyping || streamingMessageId) return null;

            // If an agent replied after the last bot message, don't show the CSAT
            const lastBotTs = new Date(lastBotMsg.timestamp || 0).getTime();
            const agentRepliedAfter = liveMessages.some(
              (m) => m.sender === "Agent" && new Date(m.timestamp || 0).getTime() > lastBotTs
            );
            if (agentRepliedAfter) return null;

            const lastMsgId = lastBotMsg._id || lastBotMsg.clientMessageId || lastBotMsg.localId || "last_bot_msg";
            const currentRating = feedbackState[lastMsgId];

            return (
              <div className="flex items-center gap-3 px-3 py-2 mt-1 mb-2 text-xs text-slate-600 bg-slate-50/90 border border-slate-100 rounded-xl w-fit animate-in fade-in duration-200">
                <span className="font-medium text-slate-600">Was this helpful?</span>
                <div className="flex items-center gap-1.5">
                  <button
                    type="button"
                    onClick={() => handleFeedback(lastMsgId, "no")}
                    className={`px-2.5 py-1 rounded-lg text-xs flex items-center gap-1 transition-all cursor-pointer border ${
                      currentRating === "no"
                        ? "bg-red-50 text-red-600 border-red-300 font-semibold shadow-xs"
                        : "bg-white text-slate-400 border-slate-200 hover:text-slate-600 hover:border-slate-300"
                    }`}
                    title="Not helpful"
                  >
                    <span className="text-sm">👎</span>
                    {currentRating === "no" && (
                      <span className="text-[11px] font-medium text-red-600">No</span>
                    )}
                  </button>

                  <button
                    type="button"
                    onClick={() => handleFeedback(lastMsgId, "yes")}
                    className={`px-2.5 py-1 rounded-lg text-xs flex items-center gap-1 transition-all cursor-pointer border ${
                      currentRating === "yes"
                        ? "bg-emerald-50 text-emerald-600 border-emerald-300 font-semibold shadow-xs"
                        : "bg-white text-slate-400 border-slate-200 hover:text-slate-600 hover:border-slate-300"
                    }`}
                    title="Helpful"
                  >
                    <span className="text-sm">👍</span>
                    {currentRating === "yes" && (
                      <span className="text-[11px] font-medium text-emerald-600">Yes</span>
                    )}
                  </button>
                </div>
              </div>
            );
          })()}

          {/* Resolved / Closed Ticket CSAT: use the same FeedbackForm/Feedback components as Message.js */}
          {(() => {
            const ticketStatus = convo?.ticketId?.status?.toLowerCase();
            if (ticketStatus === "resolved") {
              return (
                <FeedbackForm
                  selectedConversation={convo}
                  setSelectedConversation={(updated) => dispatch(setConvo(updated))}
                  setConversations={() => {}}
                  setupDetails={setupDetails}
                />
              );
            }
            if (ticketStatus === "closed") {
              return (
                <Feedback
                  selectedConversation={convo}
                  setupDetails={setupDetails}
                />
              );
            }
            return null;
          })()}

          {/* AI Thinking & Loading Progress Bubble (DexyAi style: Thinking... -> Gathering information...) */}
          {botTyping && (
            <div className="flex flex-col items-start mb-2 mr-[15%] animate-in fade-in duration-200">
              <div className="flex items-center gap-2 mb-1.5 ml-0.5">
                <DexyBotIcon className="w-5 h-5" dotClass="w-1 h-1" gap="gap-[2px]" />
                <span className="text-xs font-semibold text-slate-700">
                  {setupDetails?.widgetCustomizations?.aiBotName || "Dexy Bot"}
                </span>
              </div>

              <div
                className="text-slate-800 text-sm px-4 py-2.5 rounded-2xl rounded-tl-sm shadow-sm inline-flex items-center border transition-all duration-300"
                style={{ background: "#f3f4f6", borderColor: "#e5e7eb" }}
              >
                <span>{thinkingStage === 0 ? "Thinking..." : "Gathering information..."}</span>
              </div>
            </div>
          )}
          {!convo?.roomId && (
            <div role="status" aria-live="polite" className="flex flex-col items-center justify-center gap-3 rounded-2xl border border-slate-200/80 bg-white px-5 py-6 text-center shadow-sm">
              {!initializationError && <span aria-hidden="true" className="h-6 w-6 rounded-full border-2 border-slate-200 border-t-indigo-500 animate-spin motion-reduce:animate-none" />}
              <div>
                <p className="text-sm font-medium text-slate-700">{initializationError ? 'Unable to start your chat' : 'Starting your chat…'}</p>
                <p className="mt-1 text-xs text-slate-400">{initializationError ? 'Please try again in a moment.' : 'Getting everything ready for you.'}</p>
              </div>
              {initializationError && <button type="button" className="text-xs font-semibold text-indigo-600" onClick={() => {
                setInitializationError(false);
                dispatch(createConvo(widgetConfigs, { 
                  automated: workflowEnabled || dexyEnabled,
                  workflowId: setupDetails?.widgetWorkflow?.workflowId || 'legacy',
                }))
                  .then(result => { if (!result?.roomId) setInitializationError(true); })
                  .catch(() => setInitializationError(true));
              }}>Try again</button>}
            </div>
          )}
          {convo?.roomId && liveMessages.length === 0 && !botTyping && (
            <div className="text-center py-3 px-4 text-xs text-slate-500 bg-white/70 rounded-xl border border-dashed border-slate-200/80 my-2">
              {dexyActive ? "Ask Dexy AI a question below." : "You can send a message below to continue."}
            </div>
          )}
        </div>

        {/* Input Area - Styled exactly like Ticket (Message.js) with pb-20 for floating footer clearance */}
        <div className="p-3 pb-20 bg-white border-t border-slate-100 shrink-0">
          {/* Attachment Preview (if selected) */}
          {attachment && (
            <div className="flex items-center justify-between p-2 mb-2 bg-slate-100 rounded-xl text-xs text-slate-700">
              <div className="flex items-center gap-1.5 truncate">
                <PaperClipIcon className="w-4 h-4 shrink-0 text-slate-500" />
                <span className="truncate">{attachment.split("/").pop()}</span>
              </div>
              <button
                type="button"
                onClick={() => {
                  setAttachment(null);
                  setAttachmentType(null);
                }}
                className="text-slate-400 hover:text-slate-700 p-1 border-none bg-transparent cursor-pointer font-bold"
                title="Remove attachment"
              >
                ✕
              </button>
            </div>
          )}
          {uploadingAttachment && (
            <div className="text-xs text-blue-600 animate-pulse mb-1.5 font-medium flex items-center gap-1.5">
              <span className="w-2 h-2 rounded-full bg-blue-600 animate-ping"></span>
              Uploading attachment...
            </div>
          )}

          <div className="bg-slate-50 hover:bg-slate-100/60 focus-within:bg-white focus-within:border-slate-300 focus-within:ring-2 focus-within:ring-slate-900/5 rounded-2xl border border-slate-200 transition-all p-2 flex flex-col">
            {/* Top: Text Input */}
            <textarea
              placeholder={convo?.roomId ? 'Type a message...' : 'Starting your chat…'}
              disabled={!convo?.roomId}
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  sendNormalMessage();
                }
              }}
              rows={2}
              className="w-full bg-transparent border-none text-xs sm:text-sm text-slate-800 placeholder-slate-400 outline-none resize-none px-1.5 py-1 focus:ring-0 leading-relaxed dexkor-scrollbar"
            />

            {/* Hidden File Input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileAttachment}
              className="hidden"
            />

            {/* Bottom: Action Buttons and Send (Toolbar identical to Message.js) */}
            <div className="flex items-center justify-between pt-1 px-1 border-t border-slate-100/60 mt-1">
              {/* Media Attachments Toolbar */}
              <div className="flex items-center gap-1 text-slate-400">
                <button
                  type="button"
                  onClick={() => fileInputRef.current?.click()}
                  className="w-7 h-7 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-200/60 transition-colors border-none bg-transparent cursor-pointer"
                  title="Attach file"
                >
                  <PaperClipIcon className="h-4 w-4" />
                </button>
                <button
                  type="button"
                  onClick={captureScreenshot}
                  className="w-7 h-7 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-200/60 transition-colors border-none bg-transparent cursor-pointer"
                  title="Take screenshot"
                >
                  <CameraIcon className="h-4 w-4" />
                </button>
                <button
                  type="button"
                  onClick={startScreenRecording}
                  className={`h-7 px-1.5 rounded-lg flex items-center gap-1 transition-colors border-none cursor-pointer ${isScreenRecording
                      ? "text-red-500 bg-red-50"
                      : "text-slate-400 hover:text-slate-700 hover:bg-slate-200/60 bg-transparent"
                    }`}
                  title="Record screen"
                >
                  {isScreenRecording && (
                    <span className="text-[10px] font-mono font-bold text-red-500">
                      {formatTime(recordingTime)}
                    </span>
                  )}
                  <VideoCameraIcon className="h-4 w-4" />
                </button>
              </div>

              {/* Voice & Send Controls */}
              <div className="flex items-center gap-1.5">
                <button
                  type="button"
                  className={`w-7 h-7 rounded-lg flex items-center justify-center transition-colors border-none bg-transparent cursor-pointer ${transcribing
                      ? "text-red-500 bg-red-50"
                      : "text-slate-400 hover:text-slate-700 hover:bg-slate-200/60"
                    }`}
                  onMouseDown={startTranscription}
                  onMouseUp={stopTranscription}
                  onTouchStart={handleTouchStart}
                  onTouchEnd={handleTouchEnd}
                  title="Hold to dictate"
                >
                  <RiSpeakLine className="h-4 w-4" />
                </button>

                <button
                  type="button"
                  className={`h-7 px-1.5 rounded-lg flex items-center gap-1 transition-colors border-none cursor-pointer ${recording
                      ? "text-red-500 bg-red-50"
                      : "text-slate-400 hover:text-slate-700 hover:bg-slate-200/60 bg-transparent"
                    }`}
                  onClick={recording ? stopRecording : startRecording}
                  title="Record voice"
                >
                  {recording && (
                    <span className="text-[10px] font-mono font-bold text-red-500">
                      {formatTime(recordingTime)}
                    </span>
                  )}
                  <MicrophoneIcon
                    className={`h-4 w-4 ${recording ? "animate-pulse text-red-500" : ""}`}
                  />
                </button>

                <button
                  type="button"
                  disabled={!convo?.roomId || (!userInput.trim() && !attachment && !recording) || uploadingAttachment}
                  onClick={recording ? stopRecording : sendNormalMessage}
                  className="w-7 h-7 rounded-full flex items-center justify-center text-white transition-all shadow-sm hover:opacity-90 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed border-none cursor-pointer ml-1"
                  style={{
                    backgroundColor:
                      setupDetails?.widgetCustomizations?.uiColor ||
                      setupDetails?.widgetCustomizations?.color1 ||
                      setupDetails?.widgetCustomizations?.primaryColor ||
                      "#2563eb",
                  }}
                  title="Send message"
                >
                  <PaperAirplaneIcon className="w-3.5 h-3.5 -rotate-45" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Original AutomatedBot UI (bot is active)
  return (
    <div className="flex flex-col h-full flex-1 min-h-0 mb-0 mt-0 overflow-hidden bg-white">
      {/* Gleap Enterprise White Header */}
      <div className="flex items-center justify-between px-4 h-14 border-b border-slate-100 shrink-0 bg-white sticky top-0 z-10">
        <button
          onClick={goBack}
          className="w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all border-none outline-none cursor-pointer"
          title="Back"
        >
          <ChevronLeft className="w-5 h-5 stroke-[2.2]" />
        </button>

        <div className="flex items-center gap-1.5 font-bold text-slate-900 text-sm tracking-tight">
          <span>Live Chat</span>
          <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block animate-pulse"></span>
        </div>

        <button
          onClick={() => {
            if (setIsOpen) setIsOpen(false);
          }}
          className="w-8 h-8 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-all border-none outline-none cursor-pointer"
          title="Close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      {/* Messages Container */}
      <div
        ref={chatContainerRef}
        className="flex-1 overflow-y-auto p-4 space-y-3.5 dexkor-scrollbar bg-slate-50/50 min-h-0"
      >
        {displayMessages.map((msg, index) => {
          const cleanedMessage = cleanAndSanitizeMessage(msg.message);
          const hasAttachments = Boolean(
            msg.attachment ||
            (Array.isArray(msg.attachments) && msg.attachments.length > 0)
          );

          return (
            <div
              key={msg.localId || msg._id || index}
              className={`flex ${msg.sender === "Customer" ? "justify-end" : "justify-start"
                } mb-2`}
            >
              {msg.sender !== "Customer" && (
                <div className="w-7 h-7 mr-2 shrink-0 flex items-center justify-center rounded-full bg-slate-800 text-white shadow-xs">
                  <Bot className="w-3.5 h-3.5 text-white" />
                </div>
              )}
              <div
                className={`max-w-[80%] rounded-2xl p-3 shadow-xs ${msg.sender === "Customer"
                    ? "bg-slate-900 text-white rounded-br-xs"
                    : "bg-white text-slate-800 border border-slate-200/90 rounded-bl-xs"
                  }`}
              >
                {hasAttachments && (
                  <div className="mb-1.5">
                    <RenderAttachment
                      attachment={msg.attachment}
                      attachmentType={msg.attachmentType}
                      attachments={msg.attachments}
                    />
                  </div>
                )}
                {cleanedMessage && (
                  <div
                    className="text-xs sm:text-sm leading-relaxed break-words [&>p]:mb-1 [&>p:last-child]:mb-0 [&>div]:mb-1 [&>div:last-child]:mb-0"
                    dangerouslySetInnerHTML={{
                      __html: cleanedMessage,
                    }}
                  />
                )}
                <p
                  className={`text-[10px] mt-1 ${msg.sender === "Customer"
                      ? "text-slate-400 text-right"
                      : "text-slate-400"
                    }`}
                >
                  {msg.timestamp
                    ? new Date(msg.timestamp).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    : "Just now"}
                </p>
              </div>
            </div>
          );
        })}

        {/* Loading indicator */}
        {loading && (
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-slate-800 text-white shadow-xs">
              <Bot className="w-3.5 h-3.5 text-white" />
            </div>
            <div className="bg-white border border-slate-200/90 rounded-2xl rounded-bl-xs px-4 py-2.5 shadow-2xs">
              <div className="flex space-x-1.5 py-1">
                <div className="w-2 h-2 bg-slate-400 rounded-full animate-bounce"></div>
                <div
                  className="w-2 h-2 bg-slate-400 rounded-full animate-bounce"
                  style={{ animationDelay: "0.15s" }}
                ></div>
                <div
                  className="w-2 h-2 bg-slate-400 rounded-full animate-bounce"
                  style={{ animationDelay: "0.3s" }}
                ></div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Input Area - Pinned to bottom flush with clean border */}
      {!botCompleted && currentQuestion && (
        <div className="p-3 pb-20 bg-white border-t border-slate-100 shrink-0">
          {/* Choice Questions */}
          {currentQuestion.type === "choice" && currentQuestion.options && (
            <div
              className="space-y-2 max-h-[300px] overflow-y-auto dexkor-scrollbar"
              style={{ overscrollBehavior: "contain" }}
            >
              {currentQuestion.options.map((choice, index) => (
                <button
                  key={index}
                  onClick={() => handleChoiceClick(choice)}
                  disabled={loading}
                  className="w-full p-3 text-left bg-slate-50 hover:bg-slate-100/80 rounded-xl border border-slate-200 text-xs sm:text-sm font-medium text-slate-800 transition-all active:scale-[0.99] disabled:opacity-50 cursor-pointer flex items-center justify-between"
                >
                  <span>{choice.label}</span>
                  <ChevronRight className="w-4 h-4 text-slate-400" />
                </button>
              ))}
            </div>
          )}

          {/* Text Input Questions */}
          {(currentQuestion.type === "data_collection" ||
            currentQuestion.type === "text") && (
              <div>
                <div className="bg-slate-50 hover:bg-slate-100/60 focus-within:bg-white focus-within:border-slate-300 focus-within:ring-2 focus-within:ring-slate-900/5 rounded-2xl border border-slate-200 transition-all p-1.5 flex items-center gap-2">
                  <input
                    placeholder={
                      currentQuestion.dataCollection?.placeholder ||
                      "Enter your response..."
                    }
                    value={userInput}
                    onChange={(e) => handleInputChange(e.target.value)}
                    onKeyPress={handleInputKeyPress}
                    disabled={loading}
                    className="w-full bg-transparent border-none text-xs sm:text-sm text-slate-800 placeholder-slate-400 outline-none px-2.5 py-1 focus:ring-0 leading-relaxed"
                  />

                  <button
                    type="button"
                    onClick={() => handleSendMessage(userInput.trim())}
                    disabled={!userInput.trim() || loading || !isValid}
                    className="w-8 h-8 rounded-full flex items-center justify-center text-white transition-all shadow-sm hover:opacity-90 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed border-none cursor-pointer shrink-0"
                    style={{
                      backgroundColor:
                        setupDetails?.widgetCustomizations?.uiColor ||
                        setupDetails?.widgetCustomizations?.color1 ||
                        setupDetails?.widgetCustomizations?.primaryColor ||
                        "#2563eb",
                    }}
                    title="Send"
                  >
                    <PaperAirplaneIcon className="w-4 h-4 -rotate-45" />
                  </button>
                </div>

                {/* Validation error */}
                {validationError && (
                  <div className="text-red-500 text-xs mt-1.5 px-2 font-medium">
                    ⚠️ {validationError}
                  </div>
                )}
              </div>
            )}

          {/* Message Questions - Auto-advance */}
          {currentQuestion.type === "message" && (
            <div className="py-2 text-center text-slate-500 text-xs font-medium animate-pulse">
              {currentQuestion.messageSettings?.autoAdvance
                ? "Message will auto-advance..."
                : "Processing..."}
            </div>
          )}
        </div>
      )}

      {/* Conversation Ended - Show back button if bot conversation ended */}
      {conversationEnded && (
        <div className="p-4 pb-20 text-center border-t border-gray-200">
          <p className="text-gray-600 mb-3">
            Thanks for chatting with our AI assistant!
          </p>
          <button
            onClick={goBack}
            className="px-4 py-2 text-white rounded-lg"
            style={{
              background:
                setupDetails?.widgetCustomizations?.uiColor ||
                setupDetails?.widgetCustomizations?.color1 ||
                setupDetails?.widgetCustomizations?.primaryColor || "#4C73DE",
            }}
          >
            Back to Menu
          </button>
        </div>
      )}
    </div>
  );
};

export default AutomatedBot;

// import React, { useEffect, useRef, useState } from "react";
// import {
//   ChevronLeftIcon,
//   PaperAirplaneIcon,
// } from "@heroicons/react/24/outline";
// import "../CSS/Message.css";
// import "../CSS/CustomerChat.css";
// import io from "socket.io-client";
// import { useSelector } from "react-redux";

// const socket = io(`${process.env.REACT_APP_CHAT_SERVER}`);

// // Utility functions
// const generateUserId = () => {
//   let userId = localStorage.getItem("chatbot_user_id");
//   if (!userId) {
//     userId = "user_" + Math.random().toString(36).substr(2, 9);
//     localStorage.setItem("chatbot_user_id", userId);
//   }
//   return userId;
// };

// const AutomatedBot = ({
//   setView,
//   setupDetails,
//   widgetConfigs,
//   setActiveIcon,
// }) => {
//   const [currentQuestion, setCurrentQuestion] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [conversationEnded, setConversationEnded] = useState(false);
//   const [userInput, setUserInput] = useState("");
//   const [initialized, setInitialized] = useState(false);
//   const [validationError, setValidationError] = useState("");
//   const [isValid, setIsValid] = useState(true);
//   const [localMessages, setLocalMessages] = useState([]);
//   const [botCompleted, setBotCompleted] = useState(false);
//   const chatContainerRef = useRef(null);
//   const processingRef = useRef(false);

//   // Get room from Redux convo
//   const convo = useSelector((state) => state.convo);

//   // Check if bot conversation was already completed in this session
//   const [botConversationCompleted, setBotConversationCompleted] = useState(() => {
//     return localStorage.getItem(`bot_completed_${convo?.roomId}`) === 'true';
//   });

//   // Combine local messages with Redux messages for display
//   const displayMessages = [...localMessages, ...(convo?.messages || [])];

//   // add near other refs / state:
// const processedMessageIdsRef = useRef(new Set());

// const genLocalId = () => `loc-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

// // helper to mark processed
// const markProcessed = (id) => {
//   if (!id) return;
//   processedMessageIdsRef.current.add(id);
// };

// // helper to check processed
// const isProcessed = (id) => {
//   if (!id) return false;
//   return processedMessageIdsRef.current.has(id);
// };

//   // Validation function
//   const validateInput = (input, currentQuestion) => {
//     if (!currentQuestion || !currentQuestion.dataCollection) {
//       return { isValid: true, error: "" };
//     }

//     const { dataCollection } = currentQuestion;

//     // Required field check
//     if (dataCollection.isRequired && (!input || input.trim().length === 0)) {
//       return { isValid: false, error: "This field is required" };
//     }

//     if (!input || input.trim().length === 0) {
//       return { isValid: true, error: "" };
//     }

//     // Length validation
//     if (
//       dataCollection.validation?.minLength &&
//       input.length < dataCollection.validation.minLength
//     ) {
//       return {
//         isValid: false,
//         error: `Minimum ${dataCollection.validation.minLength} characters required`,
//       };
//     }

//     if (
//       dataCollection.validation?.maxLength &&
//       input.length > dataCollection.validation.maxLength
//     ) {
//       return {
//         isValid: false,
//         error: `Maximum ${dataCollection.validation.maxLength} characters allowed`,
//       };
//     }

//     // Data type validation
//     switch (dataCollection.dataType) {
//       case "email":
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(input)) {
//           return {
//             isValid: false,
//             error: "Please enter a valid email address",
//           };
//         }
//         break;

//       case "phone":
//         const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
//         const cleanPhone = input.replace(/[\s\-\(\)]/g, "");
//         if (!phoneRegex.test(cleanPhone)) {
//           return { isValid: false, error: "Please enter a valid phone number" };
//         }
//         break;

//       case "number":
//         if (isNaN(Number(input))) {
//           return { isValid: false, error: "Please enter a valid number" };
//         }
//         break;

//       case "url":
//         try {
//           new URL(input);
//         } catch {
//           return { isValid: false, error: "Please enter a valid URL" };
//         }
//         break;

//       case "name":
//         const nameRegex = /^[a-zA-Z\s]{2,50}$/;
//         if (!nameRegex.test(input)) {
//           return {
//             isValid: false,
//             error: "Please enter a valid name (2-50 characters, letters only)",
//           };
//         }
//         break;
//     }

//     // Custom pattern validation
//     if (dataCollection.validation?.pattern) {
//       const customRegex = new RegExp(dataCollection.validation.pattern);
//       if (!customRegex.test(input)) {
//         return {
//           isValid: false,
//           error:
//             dataCollection.validation.errorMessage || "Invalid input format",
//         };
//       }
//     }

//     return { isValid: true, error: "" };
//   };

//   // Input change handler with validation
//   const handleInputChange = (value) => {
//     setUserInput(value);

//     if (currentQuestion && currentQuestion.type === "data_collection") {
//       const validation = validateInput(value, currentQuestion);
//       setIsValid(validation.isValid);
//       setValidationError(validation.error);
//     } else {
//       setIsValid(true);
//       setValidationError("");
//     }
//   };

//   // Clear validation when question changes
//   useEffect(() => {
//     setValidationError("");
//     setIsValid(true);
//     setUserInput("");
//   }, [currentQuestion]);

//   // Auto-scroll to bottom when messages change
//   useEffect(() => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTo({
//         top: chatContainerRef.current.scrollHeight,
//         behavior: "smooth",
//       });
//     }
//   }, [displayMessages]);

//   // Initialize chat when component mounts - ONLY if bot hasn't completed
//   useEffect(() => {
//     if (!initialized && !processingRef.current && convo?.roomId && !botConversationCompleted) {
//       initializeChat();
//     } else if (botConversationCompleted && convo?.roomId) {
//       // Bot already completed, show normal chat interface
//       setBotCompleted(true);
//       setInitialized(true);
//     }
//   }, [initialized, convo, botConversationCompleted]);

//   const initializeChat = async () => {
//     if (processingRef.current) return;
//     processingRef.current = true;

//     try {
//       setLoading(true);
//       console.log("🤖 Initializing automated chat for:", widgetConfigs.uniquePartnerId);

//       const response = await fetch(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/start?uniquePartnerId=${widgetConfigs.uniquePartnerId}`
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const firstQuestion = await response.json();
//       console.log("📝 First question received:", firstQuestion);

//       setCurrentQuestion(firstQuestion);
//       setInitialized(true);

//       // Send bot message via socket
//       setTimeout(() => {
//         sendBotMessage(firstQuestion.text);

//         // Handle auto-advance for message types
//         if (
//           firstQuestion.type === "message" &&
//           firstQuestion.messageSettings?.autoAdvance
//         ) {
//           setTimeout(() => {
//             handleAutoAdvance(firstQuestion);
//           }, firstQuestion.messageSettings.delay || 1500);
//         }
//       }, 500);

//     } catch (error) {
//       console.error("❌ Failed to initialize automated chat:", error);
//       // If bot fails, fall back to normal chat
//       setBotCompleted(true);
//       setInitialized(true);
//     } finally {
//       setLoading(false);
//       processingRef.current = false;
//     }
//   };

//   const sendBotMessage = (messageText) => {
//     if (!convo?.roomId) {
//       console.error("No room ID available");
//       return;
//     }

//     const localId = genLocalId();

//     const botMessage = {
//       localId,
//       room: convo.roomId,
//       sender: "Agent",
//       senderId: "",
//       message: messageText,
//       attachment: null,
//       attachmentType: null,
//       timestamp: new Date().toISOString(),
//     };

//     console.log("🤖 Sending bot message:", botMessage);

//     // mark processed so server echo won't duplicate
//     markProcessed(localId);

//     // Add to local messages for immediate display (defensive check)
//     setLocalMessages((prev) => {
//       if (prev.some(m => m.localId === localId)) return prev;
//       return [...prev, botMessage];
//     });

//     socket.emit("message", botMessage);
//   };

//   const sendUserMessage = (messageText) => {
//     if (!convo?.roomId) {
//       console.error("No room ID available");
//       return;
//     }

//     const customerDetails = JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details")) || {};
//     const localId = genLocalId();

//     const userMessage = {
//       localId,
//       room: convo.roomId,
//       sender: "Customer",
//       senderId: customerDetails?._id || "",
//       message: messageText,
//       attachment: null,
//       attachmentType: null,
//       timestamp: new Date().toISOString(),
//     };

//     console.log("👤 Sending user message:", userMessage);

//     // mark processed so server echo won't duplicate
//     markProcessed(localId);

//     // Add to local messages for immediate display (defensive)
//     setLocalMessages((prev) => {
//       if (prev.some(m => m.localId === localId)) return prev;
//       return [...prev, userMessage];
//     });

//     socket.emit("message", userMessage);
//   };

//   const sendNormalMessage = () => {
//     if (!convo?.roomId) {
//       console.error("Can not send message, convo missing!");
//       return;
//     }

//     const inputMessage = userInput.trim();
//     if (inputMessage) {
//       const customerDetails = JSON.parse(localStorage.getItem("dexkor-chat-widget-customer-details")) || {};
//       const localId = genLocalId();

//       const msg = {
//         localId,
//         room: convo.roomId,
//         sender: "Customer",
//         senderId: customerDetails?._id || "",
//         message: inputMessage,
//         attachment: null,
//         attachmentType: null,
//         timestamp: new Date().toISOString(),
//       };

//       // mark processed
//       markProcessed(localId);

//       socket.emit("message", msg);
//       setUserInput("");

//       // Add to local messages for immediate display (defensive)
//       setLocalMessages(prev => {
//         if (prev.some(m => m.localId === localId)) return prev;
//         return [...prev, msg];
//       });
//     }
//   };

//   const handleAutoAdvance = async (currentQ) => {
//     if (processingRef.current) return;
//     processingRef.current = true;

//     try {
//       if (!currentQ.nextQuestionId) {
//         console.log("🔚 No next question, ending bot conversation");
//         setTimeout(() => {
//           sendBotMessage("Thank you for your time! I'm now connecting you with a live agent who can help you further.");
//           // Mark bot conversation as completed
//           completeBotConversation();
//         }, 800);
//         setCurrentQuestion(null);
//         return;
//       }

//       setLoading(true);
//       console.log("➡️ Auto-advancing to:", currentQ.nextQuestionId);

//       const response = await fetch(
//         `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/${currentQ.nextQuestionId}?uniquePartnerId=${widgetConfigs.uniquePartnerId}`
//       );

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const nextQuestion = await response.json();
//       console.log("📝 Next question loaded:", nextQuestion.text);

//       setCurrentQuestion(nextQuestion);

//       setTimeout(() => {
//         sendBotMessage(nextQuestion.text);

//         // Continue auto-advance if needed
//         if (
//           nextQuestion.type === "message" &&
//           nextQuestion.messageSettings?.autoAdvance
//         ) {
//           setTimeout(() => {
//             handleAutoAdvance(nextQuestion);
//           }, nextQuestion.messageSettings.delay || 1500);
//         }
//       }, 800);
//     } catch (error) {
//       console.error("❌ Error in auto-advance:", error);
//       sendBotMessage("Sorry, something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//       processingRef.current = false;
//     }
//   };

//   const completeBotConversation = () => {
//     setBotCompleted(true);
//     setConversationEnded(false); // Don't end conversation, just transition to live chat
//     setCurrentQuestion(null);

//     // Mark bot conversation as completed in localStorage
//     if (convo?.roomId) {
//       localStorage.setItem(`bot_completed_${convo.roomId}`, 'true');
//       setBotConversationCompleted(true);
//     }
//   };

//   const handleSendMessage = async (userAnswer) => {
//     if (processingRef.current) return;

//     // If bot is active, validate and process bot flow
//     if (!botCompleted && currentQuestion) {
//       // ✅ Add client-side validation before sending
//       if (currentQuestion && currentQuestion.type === "data_collection") {
//         const validation = validateInput(userAnswer, currentQuestion);
//         if (!validation.isValid) {
//           setValidationError(validation.error);
//           setIsValid(false);
//           return;
//         }
//       }

//       processingRef.current = true;

//       try {
//         setLoading(true);
//         setValidationError("");

//         // Send user message via socket
//         if (userAnswer && userAnswer.trim()) {
//           sendUserMessage(userAnswer);
//           setUserInput("");
//         }

//         console.log("💬 Processing user response:", userAnswer);

//         const response = await fetch(
//           `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/chatbot/questions/answer`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               userId: generateUserId(),
//               questionId: currentQuestion._id,
//               answer: userAnswer || "",
//               uniquePartnerId: widgetConfigs.uniquePartnerId,
//             }),
//           }
//         );

//         if (!response.ok) {
//           const errorData = await response.json().catch(() => ({}));
//           if (response.status === 400 && errorData.validationError) {
//             setValidationError(errorData.validationError);
//             setIsValid(false);
//             return;
//           }
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const result = await response.json();
//         console.log("📨 API Response:", result);

//         // Handle response based on action
//         switch (result.action) {
//           case "external_link":
//             console.log("🔗 Opening external link:", result.externalLink);
//             if (result.externalLink) {
//               window.open(result.externalLink, "_blank", "noopener,noreferrer");
//             }

//             setTimeout(() => {
//               if (result.nextQuestion) {
//                 sendBotMessage("Link opened! Meanwhile...");
//                 setTimeout(() => {
//                   setCurrentQuestion(result.nextQuestion);
//                   sendBotMessage(result.nextQuestion.text);
//                 }, 1000);
//               } else {
//                 sendBotMessage("Link opened in new tab. Thank you!");
//                 completeBotConversation();
//               }
//             }, 800);
//             break;

//           case "external_link_with_followup":
//             console.log("🔗 Opening external link with followup:", result.externalLink);
//             if (result.externalLink) {
//               window.open(result.externalLink, "_blank", "noopener,noreferrer");
//             }

//             if (result.nextQuestion) {
//               setTimeout(() => {
//                 setCurrentQuestion(result.nextQuestion);
//                 sendBotMessage("Great! I've opened the link in a new tab.");
//                 setTimeout(() => {
//                   sendBotMessage(result.nextQuestion.text);
//                 }, 1000);
//               }, 800);
//             }
//             break;

//           case "end_conversation":
//             setTimeout(() => {
//               sendBotMessage(
//                 result.message || "Thank you for your time! I'm now connecting you with a live agent."
//               );
//               completeBotConversation();
//             }, 800);
//             setCurrentQuestion(null);
//             break;

//           case "next_question":
//           default:
//             if (result.externalLink) {
//               console.log("🔗 Opening external link from next_question:", result.externalLink);
//               window.open(result.externalLink, "_blank", "noopener,noreferrer");
//             }

//             if (result.nextQuestion) {
//               console.log("➡️ Moving to next question:", result.nextQuestion.text);
//               setCurrentQuestion(result.nextQuestion);

//               setTimeout(() => {
//                 if (result.externalLink) {
//                   sendBotMessage("I've opened the link in a new tab. Meanwhile...");
//                   setTimeout(() => {
//                     sendBotMessage(result.nextQuestion.text);
//                   }, 1000);
//                 } else {
//                   sendBotMessage(result.nextQuestion.text);
//                 }

//                 if (
//                   result.nextQuestion.type === "message" &&
//                   result.nextQuestion.messageSettings?.autoAdvance
//                 ) {
//                   setTimeout(() => {
//                     handleAutoAdvance(result.nextQuestion);
//                   }, result.nextQuestion.messageSettings.delay || 1500);
//                 }
//               }, 800);
//             } else {
//               setTimeout(() => {
//                 sendBotMessage("Thank you for your time! I'm now connecting you with a live agent.");
//                 completeBotConversation();
//               }, 800);
//               setCurrentQuestion(null);
//             }
//             break;
//         }
//       } catch (error) {
//         console.error("❌ Error processing message:", error);
//         sendBotMessage("Sorry, something went wrong. Please try again.");
//       } finally {
//         setLoading(false);
//         processingRef.current = false;
//       }
//     } else {
//       // Bot conversation ended or already completed - send normal message to live agent
//       if (userAnswer && userAnswer.trim()) {
//         sendUserMessage(userAnswer);
//         setUserInput("");
//       }
//     }
//   };

//   const handleInputKeyPress = (e) => {
//     if (e.key === "Enter" && !loading && userInput.trim() && isValid) {
//       if (botCompleted) {
//         sendNormalMessage();
//       } else {
//         handleSendMessage(userInput.trim());
//       }
//     }
//   };

//   const handleChoiceClick = (choice) => {
//     if (loading) return;

//     console.log("🎯 Choice clicked:", choice);

//     if (choice.actionType === "external_link" && choice.actionValue) {
//       console.log("🔗 Opening external link from choice:", choice.actionValue);
//       window.open(choice.actionValue, "_blank", "noopener,noreferrer");
//     }

//     handleSendMessage(choice.label);
//   };

//   useEffect(() => {
//     if (!convo?.roomId) return;

//     // named handlers so off() works reliably
//     const handleIncomingMessage = (message) => {
//       try {
//         // Normalize timestamp if server sends number/date
//         if (message && message.timestamp && typeof message.timestamp !== "string") {
//           message.timestamp = new Date(message.timestamp).toISOString();
//         }

//         // Identify an incoming id: prefer server localId if present, else fallback to a signature
//         const incomingId =
//           message.localId ||
//           `${message.sender || "s"}_${message.senderId || ""}_${message.timestamp || ""}_${message.message || ""}`;

//         // If already processed, skip
//         if (isProcessed(incomingId)) {
//           // console.log("Skipping already processed message:", incomingId);
//           return;
//         }

//         // mark processed
//         markProcessed(incomingId);

//         // Only add if it belongs to this chat room
//         if (message.room === convo.roomId) {
//           setLocalMessages((prev) => {
//             const exists = prev.some(m =>
//               (m.localId && message.localId && m.localId === message.localId) ||
//               (m.message === message.message && m.timestamp === message.timestamp && m.sender === message.sender)
//             );
//             if (exists) return prev;
//             return [...prev, message];
//           });
//         }
//       } catch (err) {
//         console.error("Error handling incoming message:", err);
//       }
//     };

//     const onConnect = () => {
//       console.log("🟢 Connected to socket, joining room:", convo.roomId);
//       socket.emit("join", [convo.roomId]);
//     };

//     // Defensive remove before add (prevents duplicate handlers)
//     socket.off("message", handleIncomingMessage);
//     // socket.off("receiveMessage", handleIncomingMessage);
//     socket.off("connect", onConnect);

//     socket.on("message", handleIncomingMessage);
//     // socket.on("receiveMessage", handleIncomingMessage);
//     socket.on("connect", onConnect);

//     return () => {
//       socket.off("message", handleIncomingMessage);
//       // socket.off("receiveMessage", handleIncomingMessage);
//       socket.off("connect", onConnect);
//     };
//   }, [convo?.roomId]);

//   const goBack = () => {
//     setView("LandingWindow");
//     setActiveIcon("home");
//   };

//   // If bot conversation was already completed, show normal chat interface
//   if (botCompleted || botConversationCompleted) {
//     return (
//       <div className="flex flex-col h-screen">
//         <div className="relative mt-4 flex-grow">
//           <div>
//             <ChevronLeftIcon
//               onClick={goBack}
//               className="w-5 h-5 text-blue-800 absolute left-3 cursor-pointer"
//             />
//             <div
//               style={{
//                 background: `linear-gradient(90deg, ${
//                   setupDetails?.widgetCustomizations?.primaryColor || "#4c73de"
//                 } 0%,  ${
//                   setupDetails?.widgetCustomizations?.secondaryColor || "#2a4dad"
//                 } 100%)`,
//                 backgroundClip: "text",
//                 color: "transparent",
//                 fontWeight: "bold",
//               }}
//               className="text-blue-800 font-semibold text-base mb-4 text-center"
//             >
//               Live Chat
//             </div>
//           </div>

//           <hr></hr>

//           {/* Messages Container - Same as Convo component */}
//           <div
//             style={{
//               overflowY: "auto",
//               maxHeight: "50vh",
//               width: "100%",
//               msOverflowStyle: "none",
//               scrollbarWidth: "none",
//             }}
//             className="p-4"
//           >
//             {/* Agent Introduction */}
//             <div className="flex flex-col items-center mb-4">
//               <div className="flex items-center">
//                 <div className="w-14 h-14 mr-1 flex items-center justify-center">
//                   <div
//                     className="w-12 h-12 rounded-full flex items-center justify-center"
//                     style={{
//                       backgroundColor: setupDetails?.widgetCustomizations?.primaryColor,
//                     }}
//                   >
//                     <span className="text-white font-bold">A</span>
//                   </div>
//                 </div>
//                 <div className="h-2 w-2 mr-2 bg-green-500 rounded-xl"></div>
//                 <div className="text-sm font-semibold">Live agent</div>
//               </div>
//             </div>

//             {/* Welcome Message */}
//             <div className="flex items-start mb-4">
//               <div className="w-8 h-8 mr-2 flex items-center justify-center">
//                 <div
//                   className="w-7 h-7 rounded-full flex items-center justify-center"
//                   style={{
//                     backgroundColor: setupDetails?.widgetCustomizations?.primaryColor,
//                   }}
//                 >
//                   <span className="text-white text-xs font-bold">A</span>
//                 </div>
//               </div>
//               <div className="border rounded-xl font-normal text-xs text-black bg-gray-200 p-3 max-w-[80%]">
//                 <span className="block mt-0">
//                   You're now speaking with a Live Agent. How can I help you today?
//                 </span>
//               </div>
//             </div>

//             {/* Conversation Messages */}
//             {displayMessages.map((msg, index) => (
//               <div
//                 key={index}
//                 className={`flex ${msg.sender === "Customer" ? "justify-end" : "justify-start"} mb-2`}
//               >
//                 {msg.sender !== "Customer" && (
//                   <div className="w-8 h-8 mr-2 flex items-center justify-center">
//                     <div
//                       className="w-7 h-7 rounded-full flex items-center justify-center"
//                       style={{
//                         backgroundColor: setupDetails?.widgetCustomizations?.primaryColor,
//                       }}
//                     >
//                       <span className="text-white text-xs font-bold">A</span>
//                     </div>
//                   </div>
//                 )}
//                 <div
//                   className={`max-w-[70%] rounded-lg p-3 ${
//                     msg.sender === "Customer"
//                       ? "bg-blue-100 text-blue-900"
//                       : "bg-gray-100 text-gray-800"
//                   }`}
//                 >
//                   <div
//   className="text-sm"
//   dangerouslySetInnerHTML={{
//     __html: msg.message?.replace(/\n/g, "<br>") || "",
//   }}
// />
//                   <p className="text-xs text-gray-500 mt-1">
//                     {new Date(msg.timestamp).toLocaleTimeString([], {
//                       hour: "2-digit",
//                       minute: "2-digit",
//                       hour12: true,
//                     })}
//                   </p>
//                 </div>
//               </div>
//             ))}

//             <div ref={chatContainerRef}></div>
//           </div>
//         </div>

//         {/* Input Area - Same as Convo component */}
//         <div className="relative mb-0 p-4">
//           <input
//             type="text"
//             placeholder="Type your message here..."
//             value={userInput}
//             onChange={(e) => setUserInput(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter") {
//                 sendNormalMessage();
//                 e.preventDefault();
//               }
//             }}
//             className="w-full p-3 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//           <div className="absolute inset-y-0 right-0 flex items-center pr-6">
//             <PaperAirplaneIcon
//               onClick={sendNormalMessage}
//               className="w-6 h-6 text-blue-900 cursor-pointer"
//               style={{
//                 color: setupDetails?.widgetCustomizations?.primaryColor,
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Original AutomatedBot UI (bot is active)
//   return (
//     <div className="flex flex-col h-full mb-0 mt-0 overflow-hidden">
//       {/* Header */}
//       <div
//         className="flex items-center justify-start z-10 p-4"
//         style={{
//           background: `linear-gradient(90deg, ${
//             setupDetails?.widgetCustomizations?.secondaryColor || "#2a4dad"
//           } 0%, ${
//             setupDetails?.widgetCustomizations?.primaryColor || "#4C73DE"
//           } 100%)`,
//           borderRadius: "20px 20px 0 0",
//         }}
//       >
//         <button
//           onClick={goBack}
//           className="p-1 h-7 w-7 rounded-md mr-2 text-white hover:bg-white hover:bg-opacity-20 transition-colors"
//         >
//           <ChevronLeftIcon className="h-5 cursor-pointer" />
//         </button>
//         <div className="text-left">
//           <p className="font-bold text-white">AI Assistant</p>
//           <div className="flex items-center justify-start text-sm">
//             <div className="text-white opacity-90">
//               Status: <span>Online</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Messages Container */}
//       <div
//         ref={chatContainerRef}
//         className="flex-1 overflow-y-auto p-4 space-y-4 dexkor-scrollbar-hidden-chat"
//       >
//         {displayMessages.map((msg, index) => (
//           <div
//             key={index}
//             className={`flex items-${
//               msg.sender === "Customer" ? "end" : "start"
//             } ${msg.sender === "Customer" ? "justify-end ml-auto" : ""}`}
//           >
//             <div className="block">
//               <div
//                 className={`${
//                   msg.sender === "Customer"
//                     ? "dexkor-customer-message-box"
//                     : "dexkor-agent-message-box"
//                 }`}
//               >
//                 <p
//                   className={`${
//                     msg.sender === "Customer"
//                       ? "dexkor-customer-message-text"
//                       : "dexkor-agent-message-text"
//                   }`}
//                 >
//                   {msg.message}
//                 </p>
//               </div>
//               <p
//                 className={`${
//                   msg.sender === "Customer"
//                     ? "dexkor-customer-timestamp"
//                     : "dexkor-agent-timestamp"
//                 }`}
//               >
//                 {new Date(msg.timestamp).toLocaleTimeString([], {
//                   hour: "2-digit",
//                   minute: "2-digit",
//                   hour12: true,
//                 })}
//               </p>
//             </div>
//           </div>
//         ))}

//         {/* Loading indicator */}
//         {loading && (
//           <div className="flex items-start">
//             <div className="dexkor-agent-message-box">
//               <div className="flex space-x-1 p-2">
//                 <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
//                 <div
//                   className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
//                   style={{ animationDelay: "0.1s" }}
//                 ></div>
//                 <div
//                   className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
//                   style={{ animationDelay: "0.2s" }}
//                 ></div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Input Area - Only show during bot conversation */}
//       {!botCompleted && currentQuestion && (
//         <div
//           className="dexkor-message-input-container p-0 border-gray-200 rounded-lg"
//           style={{
//             border: `1px solid ${
//               setupDetails?.widgetCustomizations.primaryColor || "#4C73DE"
//             }`,
//           }}
//         >
//           {/* Choice Questions */}
//           {currentQuestion.type === "choice" && currentQuestion.options && (
//             <div className="p-3 space-y-2">
//               {currentQuestion.options.map((choice, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handleChoiceClick(choice)}
//                   disabled={loading}
//                   className="w-full p-3 text-left bg-gray-100 hover:bg-gray-200 rounded-lg transition disabled:opacity-50 text-sm"
//                   style={{
//                     borderLeft: `4px solid ${
//                       setupDetails?.widgetCustomizations.primaryColor || "#4C73DE"
//                     }`,
//                   }}
//                 >
//                   {choice.label}
//                 </button>
//               ))}
//             </div>
//           )}

//           {/* Text Input Questions */}
//           {(currentQuestion.type === "data_collection" ||
//             currentQuestion.type === "text") && (
//             <div className="px-4 py-4 relative">
//               <div
//                 className="relative rounded-full border bg-white w-full max-w-md mx-auto"
//                 style={{
//                   border: "1px solid #d1d5db",
//                 }}
//               >
//                 <input
//                   placeholder={
//                     currentQuestion.dataCollection?.placeholder || "Ask me anything"
//                   }
//                   value={userInput}
//                   onChange={(e) => handleInputChange(e.target.value)}
//                   onKeyPress={handleInputKeyPress}
//                   disabled={loading}
//                   className="w-full py-2 px-4 pr-12 rounded-full border-none text-sm focus:outline-none bg-transparent"
//                   style={{
//                     fontSize: "14px",
//                     color: "#9ca3af",
//                     fontWeight: "400",
//                   }}
//                 />

//                 <button
//                   onClick={() => handleSendMessage(userInput.trim())}
//                   disabled={!userInput.trim() || loading || !isValid}
//                   className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white rounded-full disabled:opacity-50 flex items-center justify-center"
//                   style={{
//                     background: setupDetails?.widgetCustomizations.primaryColor || "#8b5cf6",
//                     width: "32px",
//                     height: "32px",
//                   }}
//                 >
//                   <PaperAirplaneIcon className="h-4 w-4" />
//                 </button>
//               </div>

//               {/* Validation error */}
//               {validationError && (
//                 <div className="text-red-500 text-xs mt-2 text-center">
//                   ⚠️ {validationError}
//                 </div>
//               )}
//             </div>
//           )}

//           {/* Message Questions - Auto-advance */}
//           {currentQuestion.type === "message" && (
//             <div className="p-3 text-center text-gray-500 text-sm">
//               {currentQuestion.messageSettings?.autoAdvance
//                 ? "Message will auto-advance..."
//                 : "Processing..."}
//             </div>
//           )}
//         </div>
//       )}

//       {/* Conversation Ended - Show back button if bot conversation ended */}
//       {conversationEnded && (
//         <div className="p-4 text-center border-t border-gray-200">
//           <p className="text-gray-600 mb-3">
//             Thanks for chatting with our AI assistant!
//           </p>
//           <button
//             onClick={goBack}
//             className="px-4 py-2 text-white rounded-lg"
//             style={{
//               background: setupDetails?.widgetCustomizations.primaryColor || "#4C73DE",
//             }}
//           >
//             Back to Menu
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AutomatedBot;
